// ==================== SHOPIFY PERSONALIZATION SCRIPT (NO COVER TYPE) ====================

const DEBUG = false;
const HBN_PERSONALIZATION_BUILD = '2026-08-28.13';

window.HBN_PERSONALIZATION_BUILD = HBN_PERSONALIZATION_BUILD;
console.info(`[HBN] Personalization build ${HBN_PERSONALIZATION_BUILD} loaded`);


function t(key, fallback = '') {
  return window.hbnI18n?.[key] || fallback;
}


// ✅ GLOBAL VARIABLES (Updated for simplified Step 2)
let currentStep = 1;
//let selectedIllustrationStyle = '3d';
let previewImages = [];
let currentPreviewIndex = 0;
let tracking_id = null;
let hbn_token = null;
let isGeneratingPreview = false;
let setupLocked = false;
let workflowPhase = 'draft';
let selectedVariant = null;
let generationStartedAt = null;
let generationDeadlineAt = null;
let previewPollPromise = null;
let previewPollCancelled = false;
let previewExperienceStarted = false;

const GENERATION_ESTIMATE_MS = 5.5 * 60 * 1000;
const FIRST_PREVIEW_POLL_DELAY_MS = 3 * 60 * 1000;
const PREVIEW_POLL_INTERVAL_MS = 15 * 1000;
const LATE_PREVIEW_POLL_INTERVAL_MS = 30 * 1000;
const MAX_PREVIEW_WAIT_MS = 20 * 60 * 1000;

const EDITION_VALUES = {
    pdf: 'PDF',
    hardcover: 'Hardcover + PDF',
    padded: 'Padded Hardcover + PDF'
};

// 🐘 Elephant text spinner (1 line at a time)
const ELEPHANT_SPINNER_LINES_FALLBACK = [
  'Sometimes AI gets playful — we take care of the final details.',
  'Want a fresh start? Refresh the page and try again.',
  'Your complete PDF book is sent within 24 hours.',
  "All stories are translated by professionals to preserve their atmosphere",
  "Your child’s character is kept consistent across the story.",
  "No time to wait? Order now and get the full PDF by email within 24 hours."
];
const ELEPHANT_DONE_LINE_FALLBACK = 'Hooray! Your magical preview is here!';

let spinnerIdx = 0;
let spinnerInterval = null;

function getSpinnerLinesForCurrentLanguage() {
  const lines = [
    t('spinnerLine1', ELEPHANT_SPINNER_LINES_FALLBACK[0]),
    t('spinnerLine2', ELEPHANT_SPINNER_LINES_FALLBACK[1]),
    t('spinnerLine3', ELEPHANT_SPINNER_LINES_FALLBACK[2]),
    t('spinnerLine4', ELEPHANT_SPINNER_LINES_FALLBACK[3]),
    t('spinnerLine5', ELEPHANT_SPINNER_LINES_FALLBACK[4]),
    t('spinnerLine6', ELEPHANT_SPINNER_LINES_FALLBACK[5])
  ].filter(Boolean);

  return lines.length ? lines : ELEPHANT_SPINNER_LINES_FALLBACK;
}

function renderSpinnerLine() {
  const target = document.getElementById('previewAnimatedLines');
  if (!target) return;

  const lines = getSpinnerLinesForCurrentLanguage();
  if (!Array.isArray(lines) || lines.length === 0) return;

  target.innerHTML = '';

  const p = document.createElement('p');
  p.className = 'line';
  p.textContent = lines[spinnerIdx];
  target.appendChild(p);

  spinnerIdx = (spinnerIdx + 1) % lines.length;
}

function startLottieTextSpinner() {
  stopLottieTextSpinner();
  spinnerIdx = 0;
  renderSpinnerLine();

  // показываем дольше, чтобы текст успевали прочитать
  spinnerInterval = setInterval(renderSpinnerLine, 6000);
}

function stopLottieTextSpinner() {
  if (spinnerInterval) clearInterval(spinnerInterval);
  spinnerInterval = null;
}

function showDoneLine() {
  stopLottieTextSpinner();

  const target = document.getElementById('previewAnimatedLines');
  if (!target) return;

  target.innerHTML = '';

  const p = document.createElement('p');
  p.className = 'line';
  p.textContent = t('doneLine', ELEPHANT_DONE_LINE_FALLBACK);
  target.appendChild(p);
}

function showSupportInterventionModal(childName) {
  const modal = document.getElementById('supportInterventionModal');
  const message = document.getElementById('supportInterventionMessage');
  const emailButton = document.getElementById('supportEmailBtn');

  if (!modal || !message) return;

  const normalizedName = String(childName || '').trim();

  const fallbackMessage =
    'It looks like it would be best for us to help you personally. Please contact us, and we will help you get the right result.';

  const messageTemplate = t(
    'supportInterventionMessage',
    fallbackMessage
  );

  message.style.display = 'block';

  message.textContent = messageTemplate.replace(
    '___NAME___',
    normalizedName
  );

  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  setTimeout(() => {
    emailButton?.focus();
  }, 0);
}

function showHelpContactModal() {
  const modal = document.getElementById('supportInterventionModal');
  const message = document.getElementById('supportInterventionMessage');
  const emailButton = document.getElementById('supportEmailBtn');

  if (!modal) return;

  // Для обычного Help не показываем персональное сообщение
  if (message) {
    message.textContent = '';
    message.style.display = 'none';
  }

  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  setTimeout(() => {
    emailButton?.focus();
  }, 0);
}

function closeSupportInterventionModal() {
  const modal = document.getElementById('supportInterventionModal');

  if (!modal) return;

  modal.style.display = 'none';
  document.body.style.overflow = '';
}
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('supportInterventionModal');
  const helpTrigger = document.getElementById('helpContactTrigger');
  const closeButton = document.getElementById('supportInterventionClose');

  helpTrigger?.addEventListener('click', showHelpContactModal);

  closeButton?.addEventListener(
    'click',
    closeSupportInterventionModal
  );

  // Закрытие кликом по затемнённому фону
  modal?.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeSupportInterventionModal();
    }
  });

  // Закрытие клавишей Escape
  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      modal?.style.display === 'flex'
    ) {
      closeSupportInterventionModal();
    }
  });
});


// ==================== CONFIGURATION ====================

const WEBHOOK_URL = 'https://automation.herobyname.com/webhook/366e362b-a69c-4cbc-b018-b2cc5c7d6158';
const MAX_IMAGE_FILE_SIZE = 10 * 1024 * 1024;
if (DEBUG) console.log('[HBN] WEBHOOK_URL =', WEBHOOK_URL);

// ==================== ID GENERATION ====================

function generateTrackingId() {
    return crypto.randomUUID();
}

function generateHbnToken() {
    const randDigit = () => Math.floor(Math.random() * 10);
    const randChar = () => String.fromCharCode(97 + Math.floor(Math.random() * 26));

    const part1 = `a${randDigit()}0${randChar()}${randDigit()}c${randDigit()}9`;
    const part2 = `${randChar()}5${randChar()}${randDigit()}`;
    const part3 = `4${randChar()}${randChar()}${randDigit()}`;
    const part4 = `${randDigit()}b${randDigit()}7`;
    const part5 = Array.from({ length: 12 }, randDigit).join('');

    return `${part1}-${part2}-${part3}-${part4}-${part5}`;
}

// ==================== WEBHOOK FUNCTION ====================

async function sendToWebhook(formData, intention) {
    if (DEBUG) console.log(`Sending ${intention} to webhook...`);

    formData.set('intention', intention);
    formData.set('timestamp', Date.now().toString());

    if (DEBUG) {
        console.log('Request data:');
        for (const [key, value] of formData.entries()) {
            if (value instanceof File) {
                console.log(`${key}: [File] ${value.name} (${value.size} bytes)`);
            } else {
                console.log(`${key}: ${value}`);
            }
        }
    }

    let response;

    try {
        response = await fetch(WEBHOOK_URL, {
            method: 'POST',
            body: formData
        });
    } catch (error) {
        console.error(`Webhook network error for ${intention}:`, error);
        throw error;
    }

    const responseText = await response.text();
    let responseData;
    let parsedAsJson = false;

    if (!responseText) {
        responseData = {};
    } else {
        try {
            responseData = JSON.parse(responseText);
            parsedAsJson = true;
        } catch {
            responseData = { message: responseText };
        }
    }

    if (DEBUG) {
        console.log('Webhook response:', {
            intention,
            status: response.status,
            ok: response.ok,
            data: responseData
        });
    }

    if (!response.ok) {
        const errorMessage =
            typeof responseData?.message === 'string'
                ? responseData.message
                : typeof responseData?.error === 'string'
                    ? responseData.error
                    : typeof responseData?.error?.message === 'string'
                        ? responseData.error.message
                        : `Webhook request failed with status ${response.status}`;

        const error = new Error(errorMessage);
        error.status = response.status;
        error.response = responseData;

        console.error(`Webhook HTTP error for ${intention}:`, {
            status: response.status,
            data: responseData
        });

        throw error;
    }

    if (!responseText || parsedAsJson) {
        return responseData;
    }

    return {
        message: responseText,
        success: true
    };
}

// Same as sendToWebhook but returns headers + status too (for Retry-After)
async function postWebhookWithHeaders(formData) {
  try {
    const res = await fetch(WEBHOOK_URL, { method: 'POST', body: formData });

    const raw = await res.text();
    let json;
    try { json = JSON.parse(raw); } catch { json = { message: raw }; }

    return {
      ok: res.ok,
      status: res.status,
      headers: res.headers,
      json
    };
  } catch (err) {
    console.error('❌ postWebhookWithHeaders error:', err);
    throw err;
  }
}

// ==================== INITIALIZATION ====================

function getProductHandleFromPage() {
    const configuredHandle = window.personalizationConfig?.productHandle;
    if (configuredHandle) return configuredHandle;

    const productUrl = document.querySelector('variant-picker[data-product-url]')?.dataset.productUrl || '';
    const match = productUrl.match(/\/products\/([^/?#]+)/);
    return match?.[1] || '';
}

function normalizeAjaxVariant(variant, productHandle) {
    const optionValues = Array.isArray(variant?.options) && variant.options.length
        ? variant.options
        : [variant?.option1, variant?.option2, variant?.option3].filter(value => value != null);

    return {
        id: Number(variant?.id),
        title: String(variant?.title || ''),
        sku: String(variant?.sku || ''),
        handle: productHandle,
        price: Number(variant?.price || 0),
        options: optionValues,
        available: variant?.available !== false
    };
}

async function hydrateShopifyVariantData() {
    const config = window.personalizationConfig || {};
    const productHandle = getProductHandleFromPage();

    if (!productHandle) {
        console.warn('[HBN] Product handle was not found. Falling back to Liquid variant data.');
        return false;
    }

    const shopRoot = window.Shopify?.routes?.root || '/';
    const normalizedRoot = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
    const productEndpoint = `${normalizedRoot}products/${encodeURIComponent(productHandle)}.js`;

    try {
        const response = await fetch(productEndpoint, {
            method: 'GET',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store'
        });

        if (!response.ok) {
            throw new Error(`Shopify Product API returned ${response.status}`);
        }

        const productData = await response.json();
        const ajaxVariants = Array.isArray(productData?.variants)
            ? productData.variants.map(variant => normalizeAjaxVariant(variant, productHandle))
            : [];

        if (!ajaxVariants.length) {
            throw new Error('Shopify Product API returned no variants');
        }

        const ajaxOptionNames = Array.isArray(productData?.options)
            ? productData.options
                .map(option => typeof option === 'string' ? option : option?.name)
                .filter(Boolean)
            : [];

        // Keep Liquid variants as a fallback if Shopify's Ajax response is
        // incomplete. Ajax values win because they reflect the active market.
        const mergedVariantMap = new Map();
        (Array.isArray(config.variants) ? config.variants : []).forEach(variant => {
            const variantId = Number(variant?.id);
            if (variantId) mergedVariantMap.set(variantId, variant);
        });
        ajaxVariants.forEach(variant => {
            if (variant.id) mergedVariantMap.set(variant.id, variant);
        });
        const mergedVariants = Array.from(mergedVariantMap.values());

        window.personalizationConfig = {
            ...config,
            productId: Number(productData.id || config.productId || 0),
            productHandle,
            productTitle: productData.title || config.productTitle || '',
            optionNames: ajaxOptionNames.length ? ajaxOptionNames : config.optionNames || [],
            variants: mergedVariants,
            variantSource: 'shopify-product-api'
        };

        window.HBN_VARIANT_DIAGNOSTICS = {
            build: HBN_PERSONALIZATION_BUILD,
            source: window.personalizationConfig.variantSource,
            endpoint: productEndpoint,
            optionNames: window.personalizationConfig.optionNames,
            ajaxVariantCount: ajaxVariants.length,
            liquidVariantCount: Array.isArray(config.variants) ? config.variants.length : 0,
            resolutionMatrix: [
                [EDITION_VALUES.pdf, 'No'],
                [EDITION_VALUES.pdf, 'Yes'],
                [EDITION_VALUES.hardcover, 'No'],
                [EDITION_VALUES.hardcover, 'Yes'],
                [EDITION_VALUES.padded, 'No'],
                [EDITION_VALUES.padded, 'Yes']
            ].map(([edition, extras]) => {
                const resolved = resolveVariant(edition, extras);
                return {
                    edition,
                    extras,
                    id: resolved?.id || null,
                    price: resolved?.price ?? null,
                    available: resolved?.available ?? false
                };
            }),
            variants: mergedVariants.map(variant => ({
                id: variant.id,
                title: variant.title,
                price: variant.price,
                available: variant.available,
                options: variant.options,
                selection: getVariantSelection(variant)
            }))
        };

        console.info('[HBN] Shopify variants loaded', window.HBN_VARIANT_DIAGNOSTICS);
        return true;
    } catch (error) {
        window.personalizationConfig = {
            ...config,
            variantSource: 'liquid-fallback'
        };

        window.HBN_VARIANT_DIAGNOSTICS = {
            build: HBN_PERSONALIZATION_BUILD,
            source: window.personalizationConfig.variantSource,
            error: error.message,
            optionNames: config.optionNames || [],
            variants: config.variants || []
        };

        console.warn('[HBN] Could not refresh variants from Shopify. Using Liquid data.', error);
        return false;
    }
}

function applyDefaultProductConfiguration() {
    const hardcover = document.querySelector('input[name="book_format"][value="hardcover"]');
    const standardCover = document.querySelector('input[name="cover_type"][value="standard"]');
    const noExtras = document.querySelector('input[name="extras_enabled"][value="no"]');

    if (hardcover) hardcover.checked = true;
    if (standardCover) standardCover.checked = true;
    if (noExtras) noExtras.checked = true;
}

document.addEventListener('DOMContentLoaded', function() {
    if (DEBUG) console.log('🚀 HBN personalization system initializing...');

    tracking_id = generateTrackingId();
    hbn_token   = generateHbnToken();
    if (DEBUG) console.log('🆔 Generated tracking_id:', tracking_id);

    // ✅ БАГ ФИКС 4: Убираем блокировку скролла при инициализации
    document.body.style.overflow = '';

    setTimeout(() => {
        if (window.personalizationConfigReady) {
            initializePersonalization();
        } else {
            const checkConfig = setInterval(() => {
                if (window.personalizationConfigReady) {
                    clearInterval(checkConfig);
                    initializePersonalization();
                }
            }, 100);
        }
    }, 100);
});

async function initializePersonalization() {
    if (DEBUG) console.log('✅ Initializing personalization...');

    const section = document.getElementById('hbn-personalization');
    if (section) section.dataset.hbnScriptBuild = HBN_PERSONALIZATION_BUILD;

    await hydrateShopifyVariantData();
    applyDefaultProductConfiguration();

    // ✅ ТОЛЬКО ИНИЦИАЛИЗАЦИЯ UI - БЕЗ ЗАПРОСОВ!
    initializeStep1();
    initializeGlobalNavigation();
    updatePhotoButtonsVisibility();
    setupDragAndDrop();
    initializePhotoHandlers();
    setupProductConfigurator();
    showStep(1);

    //setTimeout(initializeDefaultStyle, 200);  //for Illustration style

    //console.log('✅ HBN personalization system ready - NO AUTO REQUESTS!');
}

// ==================== STEP 1: BASIC DATA ====================

function initializeStep1() {
    // ✅ ТОЛЬКО UI ИНИЦИАЛИЗАЦИЯ - БЕЗ WEBHOOK ЗАПРОСОВ!
    updateStepIndicator();
    setupGenderSelection();
    setupFormValidation();
    setupLanguageSelection();
    setupEyeColorField();
    setupStep1Extras();

    // ✅ НЕ ОТПРАВЛЯЕМ ЗАПРОСЫ ПРИ ИНИЦИАЛИЗАЦИИ
    setTimeout(initializePhotoHandlers, 100);

    if (DEBUG) console.log('1️⃣ Step 1 initialized - UI ONLY, no requests');
}

function setupGenderSelection() {
    document.querySelectorAll('input[name="gender"]').forEach(radio => {
        radio.addEventListener('change', function() {
            document.querySelectorAll('.gender-option').forEach(option => {
                option.classList.remove('selected');
            });

            this.parentElement.classList.add('selected');
            if (DEBUG) console.log('👫 Gender selected:', this.value);
        });
    });
}

function setupLanguageSelection() {
    const languageSelect = document.getElementById('bookLanguage');
    if (languageSelect) {
        languageSelect.addEventListener('change', function() {
            this.style.borderColor = this.value ? '#28a745' : '#e9ecef';
            updateConfiguratorSummary();
            if (DEBUG) console.log('🌍 Language selected:', this.value);
        });
    }
}

function normalizeOptionValue(value) {
    return String(value || '').trim().toLowerCase();
}

function canonicalEditionValue(value) {
    const normalized = normalizeOptionValue(value);

    if (normalized.includes('padded') && normalized.includes('hardcover')) return 'padded';
    if (normalized.includes('hardcover')) return 'hardcover';
    if (
        normalized === 'pdf' ||
        normalized.includes('pdf only') ||
        normalized.includes('only pdf')
    ) {
        return 'pdf';
    }

    return normalized;
}

function canonicalExtrasValue(value) {
    const normalized = normalizeOptionValue(value);

    if (
        normalized === 'yes' ||
        normalized === 'add extras' ||
        normalized === 'w extras' ||
        normalized === 'with extras' ||
        normalized.includes('add extra') ||
        normalized.includes('with extra')
    ) {
        return 'yes';
    }

    if (
        normalized === 'no' ||
        normalized === 'no extras' ||
        normalized === 'without extras' ||
        normalized.includes('without extra')
    ) {
        return 'no';
    }

    return normalized;
}

function getSelectedEditionValue() {
    const format = document.querySelector('input[name="book_format"]:checked')?.value || 'pdf';

    if (format === 'pdf') return EDITION_VALUES.pdf;

    const cover = document.querySelector('input[name="cover_type"]:checked')?.value || 'standard';
    return cover === 'padded' ? EDITION_VALUES.padded : EDITION_VALUES.hardcover;
}

function isExtrasEnabled() {
    return document.querySelector('input[name="extras_enabled"]:checked')?.value === 'yes';
}

function getSelectedExtrasValue() {
    return isExtrasEnabled() ? 'Yes' : 'No';
}

function findProductOptionIndex(optionName, fallbackIndex) {
    const names = window.personalizationConfig?.optionNames || [];
    const index = names.findIndex(name => normalizeOptionValue(name) === normalizeOptionValue(optionName));
    return index >= 0 ? index : fallbackIndex;
}

function parseCombinedVariantValue(value) {
    const parts = String(value || '')
        .split('|')
        .map(part => part.trim())
        .filter(Boolean);

    if (parts.length < 2) return null;

    return {
        edition: parts.slice(0, -1).join(' | '),
        extras: parts[parts.length - 1]
    };
}

function getCombinedSelectionFromValue(value) {
    const parsed = parseCombinedVariantValue(value);
    if (!parsed) return null;

    return {
        edition: canonicalEditionValue(parsed.edition),
        extras: canonicalExtrasValue(parsed.extras)
    };
}

function getVariantSelectionFromSku(sku) {
    const normalizedSku = String(sku || '')
        .trim()
        .toLowerCase()
        .replace(/[_\s]+/g, '-');
    const match = normalizedSku.match(
        /(?:^|-)(padded-hardcover|padded-hc|phc|hardcover|hc|pdf)-(no|yes)(?:-extras)?$/
    );

    if (!match) return null;

    const editionToken = match[1];
    const edition = editionToken === 'pdf'
        ? 'pdf'
        : ['phc', 'padded-hc', 'padded-hardcover'].includes(editionToken)
            ? 'padded'
            : 'hardcover';

    return {
        edition,
        extras: match[2]
    };
}

function getVariantSelection(variant) {
    // SKU is not translated by Shopify, so it is the stable primary key for
    // Edition + Extras on every storefront language.
    const skuSelection = getVariantSelectionFromSku(variant?.sku);
    if (skuSelection) return skuSelection;

    // Keep text matching only as a fallback for legacy products without the
    // expected SKU suffix.
    const options = Array.isArray(variant?.options) ? variant.options : [];
    const optionNames = window.personalizationConfig?.optionNames || [];
    const combinedOptionIndex = optionNames.findIndex(name => {
        const normalized = normalizeOptionValue(name);
        return normalized.includes('edition') && normalized.includes('extras');
    });

    if (combinedOptionIndex >= 0 || options.length === 1) {
        const combinedCandidates = [
            options[combinedOptionIndex >= 0 ? combinedOptionIndex : 0],
            variant?.title
        ];

        for (const candidate of combinedCandidates) {
            const selection = getCombinedSelectionFromValue(candidate);
            if (selection) return selection;
        }
    }

    const editionIndex = findProductOptionIndex('Edition', 0);
    const extrasIndex = findProductOptionIndex('Extras', 1);

    return {
        edition: canonicalEditionValue(options[editionIndex]),
        extras: canonicalExtrasValue(options[extrasIndex])
    };
}

function findThemePickerVariantId(requestedEdition, requestedExtras) {
    const productId = String(window.personalizationConfig?.productId || '');
    const selector = productId
        ? `variant-picker[data-product-id="${productId}"] option[data-variant-id]`
        : 'variant-picker option[data-variant-id]';

    for (const option of document.querySelectorAll(selector)) {
        const selection = getCombinedSelectionFromValue(option.value || option.textContent);
        if (!selection) continue;

        if (
            selection.edition === requestedEdition &&
            selection.extras === requestedExtras
        ) {
            const variantId = Number(option.dataset.variantId || 0);
            if (variantId) return variantId;
        }
    }

    return null;
}

function resolveVariant(edition = getSelectedEditionValue(), extras = getSelectedExtrasValue()) {
    const variants = window.personalizationConfig?.variants || [];
    const requestedEdition = canonicalEditionValue(edition);
    const requestedExtras = canonicalExtrasValue(extras);

    const matchedByOptions = variants.find(variant => {
        const selection = getVariantSelection(variant);
        return selection.edition === requestedEdition && selection.extras === requestedExtras;
    });

    if (matchedByOptions) return matchedByOptions;

    // Horizon exposes the exact selected-value → variant-ID mapping in its
    // variant picker. This also covers unusual option labels or stale titles.
    const themePickerVariantId = findThemePickerVariantId(requestedEdition, requestedExtras);
    if (themePickerVariantId) {
        const matchedByThemePicker = variants.find(
            variant => Number(variant?.id) === themePickerVariantId
        );
        if (matchedByThemePicker) return matchedByThemePicker;
    }

    return null;
}

function getAvailableVariantSelections() {
    const variants = window.personalizationConfig?.variants || [];
    const supportedEditions = new Set(['pdf', 'hardcover', 'padded']);
    const supportedExtras = new Set(['no', 'yes']);
    const selections = new Map();

    variants.forEach(variant => {
        if (!variant || variant.available === false) return;

        const selection = getVariantSelection(variant);
        if (
            !supportedEditions.has(selection.edition) ||
            !supportedExtras.has(selection.extras)
        ) {
            return;
        }

        const key = `${selection.edition}|${selection.extras}`;
        if (!selections.has(key)) selections.set(key, selection);
    });

    return Array.from(selections.values());
}

function findAvailableSelection(availableSelections, edition, extras) {
    const requestedEdition = canonicalEditionValue(edition);
    const requestedExtras = canonicalExtrasValue(extras);

    return availableSelections.find(selection => (
        selection.edition === requestedEdition &&
        selection.extras === requestedExtras
    )) || null;
}

function chooseAvailableSelection(availableSelections, edition, extras) {
    if (!availableSelections.length) return null;

    const requestedEdition = canonicalEditionValue(edition);
    const requestedExtras = canonicalExtrasValue(extras);
    const otherPrintEdition = requestedEdition === 'hardcover'
        ? 'padded'
        : requestedEdition === 'padded'
            ? 'hardcover'
            : null;

    // Never change Extras while choosing a fallback edition. Otherwise a cover
    // change on Step 1 could silently turn No extras into Add extras.
    const priorities = [[requestedEdition, requestedExtras]];

    if (otherPrintEdition) {
        priorities.push([otherPrintEdition, requestedExtras]);
    }

    priorities.push(
        ['hardcover', requestedExtras],
        ['padded', requestedExtras],
        ['pdf', requestedExtras]
    );

    for (const [candidateEdition, candidateExtras] of priorities) {
        const match = findAvailableSelection(
            availableSelections,
            candidateEdition,
            candidateExtras
        );
        if (match) return match;
    }

    return null;
}

function selectConfiguratorVariant(selection) {
    if (!selection) return;

    const formatValue = selection.edition === 'pdf' ? 'pdf' : 'hardcover';
    const coverValue = selection.edition === 'padded' ? 'padded' : 'standard';
    const extrasValue = selection.extras === 'yes' ? 'yes' : 'no';

    const formatInput = document.querySelector(
        `input[name="book_format"][value="${formatValue}"]`
    );
    const coverInput = document.querySelector(
        `input[name="cover_type"][value="${coverValue}"]`
    );
    const extrasInput = document.querySelector(
        `input[name="extras_enabled"][value="${extrasValue}"]`
    );

    if (formatInput) formatInput.checked = true;
    if (coverInput) coverInput.checked = true;
    if (extrasInput) extrasInput.checked = true;
}

function setConfiguratorChoiceAvailability(input, available) {
    if (!input) return;

    const choice = input.closest('.hbn-config-choice');
    input.disabled = !available;
    input.setAttribute('aria-disabled', available ? 'false' : 'true');

    if (choice) {
        choice.hidden = !available;
        choice.classList.toggle('hbn-variant-choice-unavailable', !available);
        choice.setAttribute('aria-hidden', available ? 'false' : 'true');
    }
}

function applyAvailableVariantConfiguration() {
    const availableSelections = getAvailableVariantSelections();

    // If Shopify reports no available variants at all, keep the controls
    // visible so validation can show the normal unavailable message.
    if (!availableSelections.length) return;

    const requestedEdition = canonicalEditionValue(getSelectedEditionValue());
    const requestedExtras = canonicalExtrasValue(getSelectedExtrasValue());
    const selectedAvailable = findAvailableSelection(
        availableSelections,
        requestedEdition,
        requestedExtras
    );

    selectConfiguratorVariant(
        selectedAvailable || chooseAvailableSelection(
            availableSelections,
            requestedEdition,
            requestedExtras
        )
    );

    const hasSelection = (edition, extras) => Boolean(
        findAvailableSelection(availableSelections, edition, extras)
    );
    const hasEdition = edition => (
        hasSelection(edition, 'no') || hasSelection(edition, 'yes')
    );

    setConfiguratorChoiceAvailability(
        document.querySelector('input[name="book_format"][value="pdf"]'),
        hasEdition('pdf')
    );
    setConfiguratorChoiceAvailability(
        document.querySelector('input[name="book_format"][value="hardcover"]'),
        hasEdition('hardcover') || hasEdition('padded')
    );
    setConfiguratorChoiceAvailability(
        document.querySelector('input[name="cover_type"][value="standard"]'),
        hasEdition('hardcover')
    );
    setConfiguratorChoiceAvailability(
        document.querySelector('input[name="cover_type"][value="padded"]'),
        hasEdition('padded')
    );

    const activeEdition = canonicalEditionValue(getSelectedEditionValue());
    setConfiguratorChoiceAvailability(
        document.querySelector('input[name="extras_enabled"][value="no"]'),
        hasSelection(activeEdition, 'no')
    );
    setConfiguratorChoiceAvailability(
        document.querySelector('input[name="extras_enabled"][value="yes"]'),
        hasSelection(activeEdition, 'yes')
    );
}

function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    const currency = window.personalizationConfig?.currency || 'EUR';

    try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency
        }).format(amount);
    } catch {
        return `${amount.toFixed(2)} ${currency}`;
    }
}

function formatSurcharge(cents) {
    const value = Number(cents || 0);
    return value > 0 ? `+${formatMoney(value)}` : t('included', 'free');
}

function getStartingPriceText(cents) {
    const formattedPrice = formatMoney(cents);
    const template = t('priceFromTemplate', 'From __HBN_PRICE__');

    if (!template.includes('__HBN_PRICE__') || normalizeOptionValue(template).includes('translation missing')) {
        return `From ${formattedPrice}`;
    }

    return template.replace('__HBN_PRICE__', formattedPrice);
}

function lockProductInformationStartingPrice() {
    const baseVariant = resolveVariant(EDITION_VALUES.hardcover, 'No');
    const personalizationSection = document.getElementById('hbn-personalization');
    const productId = String(window.personalizationConfig?.productId || '');

    if (!baseVariant || !personalizationSection || !productId) return;

    const expectedText = getStartingPriceText(baseVariant.price);
    const expectedComparableText = expectedText.replace(/\s+/g, ' ').trim();
    const priceBlocks = Array.from(
        document.querySelectorAll(`product-price[data-product-id="${productId}"]`)
    ).filter(block => {
        if (block.closest('#hbn-personalization')) return false;
        return Boolean(block.compareDocumentPosition(personalizationSection) & Node.DOCUMENT_POSITION_FOLLOWING);
    });

    priceBlocks.forEach(priceBlock => {
        const renderStartingPrice = () => {
            const priceContainer = priceBlock.querySelector('[ref="priceContainer"]');
            if (!priceContainer) return;

            const currentText = priceContainer.textContent.replace(/\s+/g, ' ').trim();
            if (currentText === expectedComparableText && priceContainer.dataset.hbnStartingPrice === 'true') return;

            const price = document.createElement('span');
            price.className = 'price';
            price.textContent = expectedText;

            priceContainer.replaceChildren(price);
            priceContainer.dataset.hbnStartingPrice = 'true';
        };

        renderStartingPrice();

        if (priceBlock.dataset.hbnStartingPriceObserver === 'true') return;

        const observer = new MutationObserver(renderStartingPrice);
        observer.observe(priceBlock, { childList: true, subtree: true, characterData: true });
        priceBlock.dataset.hbnStartingPriceObserver = 'true';
    });
}

function renderConfiguratorChoiceState(groupName) {
    document.querySelectorAll(`input[name="${groupName}"]`).forEach(input => {
        input.closest('.hbn-config-choice')?.classList.toggle('selected', input.checked);
    });
}

function getDetailedExtrasSummaryLabel(extras) {
    if (extras !== 'Yes') {
        return t('summaryNoExtras', t('extrasNo', 'No extras'));
    }

    const animalType = getSelectedExtraType('animal_type');
    const objectType = getSelectedExtraType('object_type');
    const hasObject = objectType !== 'none';

    if (animalType === 'pet' && hasObject) {
        return t('summaryPetObject', 'Pet and object');
    }

    if (animalType === 'favorite_animal' && hasObject) {
        return t('summaryAnimalObject', 'Animal and object');
    }

    if (animalType === 'pet') {
        return t('summaryPet', 'Pet');
    }

    if (animalType === 'favorite_animal') {
        return t('summaryFavoriteAnimal', 'Favorite animal');
    }

    if (hasObject) {
        return t('summaryObject', 'Object');
    }

    return t('extrasYes', 'Add special details');
}

function updateConfiguratorSummary() {
    const edition = getSelectedEditionValue();
    const extras = getSelectedExtrasValue();
    const variant = resolveVariant(edition, extras);
    const languageSelect = document.getElementById('bookLanguage');

    const pdfNo = resolveVariant(EDITION_VALUES.pdf, 'No');
    const hardcoverNo = resolveVariant(EDITION_VALUES.hardcover, 'No');
    const paddedNo = resolveVariant(EDITION_VALUES.padded, 'No');
    const sameEditionNo = resolveVariant(edition, 'No');
    const sameEditionYes = resolveVariant(edition, 'Yes');

    const editionLabels = {
        [EDITION_VALUES.pdf]: t('editionPdf', 'PDF'),
        [EDITION_VALUES.hardcover]: t('editionHardcover', 'Hardcover + PDF'),
        [EDITION_VALUES.padded]: t('editionPadded', 'Padded Hardcover + PDF')
    };

    const summaryEditionLabel = document.getElementById('summaryEditionLabel');
    const summaryEditionPrice = document.getElementById('summaryEditionPrice');
    const summaryLanguage = document.getElementById('summaryLanguage');
    const summaryExtrasLabel = document.getElementById('summaryExtrasLabel');
    const summaryExtrasPrice = document.getElementById('summaryExtrasPrice');
    const summaryTotal = document.getElementById('summaryTotal');

    if (summaryEditionLabel) summaryEditionLabel.textContent = editionLabels[edition] || edition;
    if (summaryEditionPrice) {
        summaryEditionPrice.textContent = sameEditionNo
            ? formatMoney(sameEditionNo.price)
            : '—';
    }
    if (summaryLanguage) {
        summaryLanguage.textContent = languageSelect?.value
            ? languageSelect.options[languageSelect.selectedIndex]?.text || languageSelect.value
            : '—';
    }
    if (summaryExtrasLabel) {
        summaryExtrasLabel.textContent = getDetailedExtrasSummaryLabel(extras);
    }
    if (summaryExtrasPrice) {
        summaryExtrasPrice.textContent = extras === 'Yes' && sameEditionYes && sameEditionNo
            ? formatMoney(sameEditionYes.price - sameEditionNo.price)
            : formatMoney(0);
    }
    if (summaryTotal) summaryTotal.textContent = variant ? formatMoney(variant.price) : '—';

    const pdfPrice = document.getElementById('pdfEditionPrice');
    const hardcoverPrice = document.getElementById('hardcoverEditionPrice');
    const paddedSurcharge = document.getElementById('paddedCoverSurcharge');
    const extrasSurcharge = document.getElementById('extrasSurcharge');

    if (pdfPrice) pdfPrice.textContent = pdfNo ? formatMoney(pdfNo.price) : '';
    if (hardcoverPrice) hardcoverPrice.textContent = hardcoverNo ? formatMoney(hardcoverNo.price) : '';
    if (paddedSurcharge) {
        paddedSurcharge.textContent = paddedNo && hardcoverNo
            ? formatSurcharge(paddedNo.price - hardcoverNo.price)
            : '';
    }
    if (extrasSurcharge) {
        extrasSurcharge.textContent = sameEditionYes && sameEditionNo
            ? formatSurcharge(sameEditionYes.price - sameEditionNo.price)
            : '';
    }
}

function renderBookConfiguration() {
    applyAvailableVariantConfiguration();
    renderConfiguratorChoiceState('book_format');
    renderConfiguratorChoiceState('cover_type');
    renderConfiguratorChoiceState('extras_enabled');

    const isHardcover = document.querySelector('input[name="book_format"]:checked')?.value === 'hardcover';
    const coverSection = document.getElementById('coverTypeSection');

    if (coverSection) {
        coverSection.hidden = !isHardcover;
        coverSection.classList.toggle('hidden', !isHardcover);
    }

    updateConfiguratorSummary();
}

function renderExtrasPackage() {
    applyAvailableVariantConfiguration();
    renderConfiguratorChoiceState('extras_enabled');
    renderConfiguratorChoiceState('book_format');
    renderConfiguratorChoiceState('cover_type');

    const panel = document.getElementById('step1ExtrasPanel');
    const enabled = isExtrasEnabled();

    if (panel) {
        panel.hidden = !enabled;
        panel.classList.toggle('hidden', !enabled);
        panel.classList.toggle('active', enabled);
        panel.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    }

    if (enabled) renderStep1ExtraFields();
    updateConfiguratorSummary();
}

function setupProductConfigurator() {
    ['book_format', 'cover_type'].forEach(groupName => {
        document.querySelectorAll(`input[name="${groupName}"]`).forEach(input => {
            input.onchange = renderBookConfiguration;
        });
    });

    document.querySelectorAll('input[name="extras_enabled"]').forEach(input => {
        input.onchange = renderExtrasPackage;
    });

    renderBookConfiguration();
    renderExtrasPackage();
    lockProductInformationStartingPrice();
}

function validateBookStep() {
    const language = document.getElementById('bookLanguage');
    const variant = resolveVariant();
    const errors = [];

    if (!language?.value) {
        errors.push(t('errorLanguageRequired', 'Please select language'));
        if (language) language.style.borderColor = '#dc3545';
    } else {
        language.style.borderColor = '#28a745';
    }

    if (!variant || !variant.available) {
        errors.push(t('errorVariantUnavailable', 'This combination is currently unavailable.'));
    }

    if (errors.length) {
        showError(errors.map(error => `• ${error}`).join('\n'));
        return false;
    }

    selectedVariant = variant;
    return true;
}

function setupEyeColorField() {
    const eyeColorSelect = document.getElementById('eyeColorSelect');
    const eyeColorManualGroup = document.getElementById('eyeColorManualGroup');
    const eyeColorManual = document.getElementById('eyeColorManual');

    if (!eyeColorSelect || !eyeColorManualGroup || !eyeColorManual) return;

    const toggleManualField = () => {
        const isManual = eyeColorSelect.value === 'manual';

        eyeColorManualGroup.classList.toggle('hidden', !isManual);
        eyeColorManualGroup.style.display = isManual ? 'block' : 'none';

        // Manual input is required only when "Enter manually" is selected
        eyeColorManual.required = isManual;
        eyeColorManual.setAttribute(
            'aria-required',
            isManual ? 'true' : 'false'
        );

        if (!isManual) {
            eyeColorManual.value = '';
            eyeColorManual.style.borderColor = '';
        }
    };

    // Using onchange instead of addEventListener prevents duplicate
    // handlers when the user returns to Step 1
    eyeColorSelect.onchange = function () {
        this.style.borderColor = this.value
            ? '#28a745'
            : '#e9ecef';

        toggleManualField();
    };

    eyeColorManual.oninput = function () {
        // Allows letters from all supported languages, spaces and hyphens
        const cleaned = this.value.replace(/[^\p{L}\s-]/gu, '');

        if (cleaned !== this.value) {
            this.value = cleaned;
        }

        this.style.borderColor = this.value.trim()
            ? '#28a745'
            : '#e9ecef';
    };

    toggleManualField();
}

function getEyeColorValue() {
    const eyeColorSelect = document.getElementById('eyeColorSelect');
    const eyeColorManual = document.getElementById('eyeColorManual');

    if (!eyeColorSelect?.value) return '';

    if (eyeColorSelect.value === 'manual') {
        return eyeColorManual?.value?.trim() || '';
    }

    const map = {
        blue: 'Blue',
        gray: 'Gray',
        green: 'Green',
        hazel: 'Hazel',
        brown: 'Brown',
        dark_brown: 'Dark brown'
    };

    return map[eyeColorSelect.value] || '';
}

function setupFormValidation() {
  const childNameInput = document.getElementById('childName');
  if (!childNameInput) return;

  // 1. На вводе — только фильтруем символы, НЕ trim()
  childNameInput.addEventListener('input', function () {
    const start = this.selectionStart;
    const end = this.selectionEnd;

    const raw = this.value; // без trim()
    const cleaned = raw.replace(/[^a-zA-Zа-яА-ЯёЁ\s-]/g, '');

    if (cleaned !== raw) {
      // сохранить каретку (иначе может прыгать)
      const delta = raw.length - cleaned.length;
      this.value = cleaned;
      const newPos = Math.max(0, start - delta);
      this.setSelectionRange(newPos, newPos);
    }

    this.style.borderColor = this.value.length > 0 ? '#28a745' : '#e9ecef';
  });

  // 2. На выходе из поля — trim краёв (как и хотел)
  childNameInput.addEventListener('blur', function () {
    const trimmed = this.value.trim();
    if (trimmed !== this.value) this.value = trimmed;
  });
}

function validateStep1() {
    const childName = document.getElementById('childName');
    const gender = document.querySelector('input[name="gender"]:checked');
    const eyeColorSelect = document.getElementById('eyeColorSelect');
    const eyeColorManual = document.getElementById('eyeColorManual');
    const photoInput = document.getElementById('childPhoto');

    let isValid = true;
    const errors = [];

    // Child name
    if (!childName?.value?.trim()) {
        errors.push(
            t(
                'errorNameRequired',
                "Please enter the child's name"
            )
        );

        if (childName) {
            childName.style.borderColor = '#dc3545';
        }

        isValid = false;

    } else if (childName.value.trim().length < 2) {
        errors.push(
            t(
                'errorNameShort',
                'Name must contain at least 2 characters'
            )
        );

        childName.style.borderColor = '#dc3545';
        isValid = false;

    } else {
        childName.style.borderColor = '#28a745';
    }

    // Gender
    if (!gender) {
        errors.push(
            t(
                'errorGenderRequired',
                'Please select gender'
            )
        );

        isValid = false;
    }

    // Eye color
    if (!eyeColorSelect?.value) {
        errors.push(
            t(
                'errorEyeColorRequired',
                'Please select the eye color'
            )
        );

        if (eyeColorSelect) {
            eyeColorSelect.style.borderColor = '#dc3545';
        }

        isValid = false;

    } else if (
        eyeColorSelect.value === 'manual' &&
        !eyeColorManual?.value?.trim()
    ) {
        errors.push(
            t(
                'errorEyeColorManualRequired',
                'Please enter the eye color'
            )
        );

        eyeColorSelect.style.borderColor = '#28a745';

        if (eyeColorManual) {
            eyeColorManual.style.borderColor = '#dc3545';
        }

        isValid = false;

    } else {
        eyeColorSelect.style.borderColor = '#28a745';

        if (eyeColorManual) {
            eyeColorManual.style.borderColor =
                eyeColorSelect.value === 'manual'
                    ? '#28a745'
                    : '';
        }
    }

    // Photo
    if (!photoInput || !photoInput.files.length) {
        errors.push(
            t(
                'errorPhotoRequired',
                'Please upload a photo before continuing.'
            )
        );

        isValid = false;
    }

    if (!isValid) {
        showError(
            errors
                .map(error => `• ${error}`)
                .join('\n')
        );
    }

    return isValid;
}

// ==================== STEP 1B: OPTIONAL ANIMAL AND OBJECT ====================

function getSelectedExtraType(groupName) {
    return document.querySelector(`input[name="${groupName}"]:checked`)?.value || 'none';
}

function setStep1Panel(panelName, shouldScroll = true) {
    const childPanel = document.getElementById('step1ChildPanel');
    const extrasPanel = document.getElementById('step1ExtrasPanel');
    const mainPreviewArea = document.getElementById('mainPreviewArea');

    if (!childPanel || !extrasPanel) return false;

    const showExtras = panelName === 'extras';

    childPanel.hidden = showExtras;
    childPanel.classList.toggle('hidden', showExtras);
    childPanel.classList.toggle('active', !showExtras);
    childPanel.setAttribute('aria-hidden', showExtras ? 'true' : 'false');

    extrasPanel.hidden = !showExtras;
    extrasPanel.classList.toggle('hidden', !showExtras);
    extrasPanel.classList.toggle('active', showExtras);
    extrasPanel.setAttribute('aria-hidden', showExtras ? 'false' : 'true');

    if (mainPreviewArea) {
        mainPreviewArea.style.display = showExtras ? 'none' : 'block';
    }

    if (shouldScroll) {
        const scrollTarget = showExtras ? extrasPanel : (mainPreviewArea || childPanel);
        setTimeout(() => {
            scrollTarget?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 50);
    }

    return true;
}

function openStep1Extras() {
    if (!validateStep1()) return false;

    renderStep1ExtraFields();
    return setStep1Panel('extras');
}

function returnToStep1Child(options = {}) {
    const shouldScroll = options.scroll !== false;
    return setStep1Panel('child', shouldScroll);
}

function toggleExtraFields(groupId, shouldShow, requiredElementIds) {
    const group = document.getElementById(groupId);
    const requiredIds = Array.isArray(requiredElementIds)
        ? requiredElementIds
        : [requiredElementIds].filter(Boolean);

    if (group) {
        group.hidden = !shouldShow;
        group.classList.toggle('hidden', !shouldShow);
        group.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    requiredIds.forEach(requiredElementId => {
        const requiredElement = document.getElementById(requiredElementId);
        if (!requiredElement) return;

        requiredElement.required = shouldShow;
        requiredElement.setAttribute('aria-required', shouldShow ? 'true' : 'false');

        if (!shouldShow) {
            requiredElement.style.borderColor = '';
        }
    });
}

function renderExtraChoiceState(groupName) {
    document.querySelectorAll(`input[name="${groupName}"]`).forEach(input => {
        input.closest('.hbn-extra-choice')?.classList.toggle('selected', input.checked);
    });
}

function renderStep1ExtraFields() {
    const animalType = getSelectedExtraType('animal_type');
    const objectType = getSelectedExtraType('object_type');

    renderExtraChoiceState('animal_type');
    renderExtraChoiceState('object_type');

    toggleExtraFields('animalPetFields', animalType === 'pet', 'animalPhoto');
    toggleExtraFields(
        'favoriteAnimalFields',
        animalType === 'favorite_animal',
        'animalDescription'
    );

    toggleExtraFields(
        'objectToyFields',
        objectType === 'toy',
        ['objectPhoto', 'objectPhotoDescription']
    );
    toggleExtraFields(
        'favoriteObjectFields',
        objectType === 'favorite_object',
        'objectDescription'
    );

    if (animalType !== 'pet') {
        document.getElementById('animalPhotoUploadZone')?.classList.remove('invalid');
    }

    if (objectType !== 'toy') {
        document.getElementById('objectPhotoUploadZone')?.classList.remove('invalid');
    }

    updateConfiguratorSummary();
}

function getExtraPhotoElements(kind) {
    const prefix = kind === 'animal' ? 'animal' : 'object';

    return {
        input: document.getElementById(`${prefix}Photo`),
        image: document.getElementById(`${prefix}PhotoPreview`),
        container: document.getElementById(`${prefix}PhotoPreviewContainer`),
        uploadZone: document.getElementById(`${prefix}PhotoUploadZone`),
        placeholder: document.getElementById(`${prefix}PhotoUploadPlaceholder`)
    };
}

function isImageFile(file) {
    return file instanceof File && file.type.startsWith('image/');
}

function clearExtraPhoto(kind, clearInput = true) {
    const { input, image, container, uploadZone, placeholder } = getExtraPhotoElements(kind);

    if (image?.dataset.previewUrl) {
        URL.revokeObjectURL(image.dataset.previewUrl);
        delete image.dataset.previewUrl;
    }

    if (image) {
        image.removeAttribute('src');
        image.hidden = true;
        image.classList.add('hidden');
    }

    if (placeholder) {
        placeholder.hidden = false;
        placeholder.classList.remove('hidden');
    }

    if (container) {
        container.hidden = true;
        container.classList.add('hidden');
    }

    if (uploadZone) {
        uploadZone.classList.remove('has-file', 'valid', 'invalid', 'is-dragover');
    }

    if (clearInput && input) {
        input.value = '';
    }
}

function showExtraPhotoPreview(kind, file) {
    const { image, container, uploadZone, placeholder } = getExtraPhotoElements(kind);
    if (!image || !container) return;

    if (image.dataset.previewUrl) {
        URL.revokeObjectURL(image.dataset.previewUrl);
    }

    const previewUrl = URL.createObjectURL(file);
    image.dataset.previewUrl = previewUrl;
    image.src = previewUrl;
    image.hidden = false;
    image.classList.remove('hidden');

    if (placeholder) {
        placeholder.hidden = true;
        placeholder.classList.add('hidden');
    }

    container.hidden = false;
    container.classList.remove('hidden');

    uploadZone?.classList.remove('invalid');
    uploadZone?.classList.remove('is-dragover');
    uploadZone?.classList.add('has-file', 'valid');
}

function handleExtraPhotoChange(kind, event) {
    const file = event.target.files?.[0];
    const { uploadZone } = getExtraPhotoElements(kind);

    if (!file) {
        clearExtraPhoto(kind, false);
        return false;
    }

    if (file.size > MAX_IMAGE_FILE_SIZE) {
        clearExtraPhoto(kind);
        uploadZone?.classList.add('invalid');
        showError(t('errorFileTooLarge', 'File too large. Maximum size: 10MB'));
        return false;
    }

    if (!isImageFile(file)) {
        clearExtraPhoto(kind);
        uploadZone?.classList.add('invalid');
        showError(t('errorUploadImage', 'Please upload an image file'));
        return false;
    }

    showExtraPhotoPreview(kind, file);
    return true;
}

function setupExtraPhotoDropZone(kind) {
    const { input, uploadZone } = getExtraPhotoElements(kind);
    if (!input || !uploadZone || uploadZone.dataset.dropReady === 'true') return;

    uploadZone.dataset.dropReady = 'true';

    ['dragenter', 'dragover'].forEach(eventName => {
        uploadZone.addEventListener(eventName, event => {
            event.preventDefault();
            event.stopPropagation();
            uploadZone.classList.add('is-dragover');
        });
    });

    uploadZone.addEventListener('dragleave', event => {
        event.preventDefault();
        event.stopPropagation();

        if (!event.relatedTarget || !uploadZone.contains(event.relatedTarget)) {
            uploadZone.classList.remove('is-dragover');
        }
    });

    uploadZone.addEventListener('drop', event => {
        event.preventDefault();
        event.stopPropagation();
        uploadZone.classList.remove('is-dragover');

        const file = event.dataTransfer?.files?.[0];
        if (!file) return;

        if (!isImageFile(file)) {
            clearExtraPhoto(kind);
            uploadZone.classList.add('invalid');
            showError(t('errorDragImage', 'Please drag an image file'));
            return;
        }

        try {
            const transfer = new DataTransfer();
            transfer.items.add(file);
            input.files = transfer.files;
        } catch (error) {
            console.error('Could not attach dropped photo:', error);
            showError(t('errorUploadImage', 'Please upload an image file'));
            return;
        }

        handleExtraPhotoChange(kind, { target: input });
    });
}

function setupStep1Extras() {
    const animalRadios = document.querySelectorAll('input[name="animal_type"]');
    const objectRadios = document.querySelectorAll('input[name="object_type"]');

    if (!animalRadios.length && !objectRadios.length) return;

    [...animalRadios, ...objectRadios].forEach(radio => {
        radio.onchange = renderStep1ExtraFields;
    });

    const animalPhoto = document.getElementById('animalPhoto');
    const objectPhoto = document.getElementById('objectPhoto');
    const removeAnimalPhotoBtn = document.getElementById('removeAnimalPhotoBtn');
    const removeObjectPhotoBtn = document.getElementById('removeObjectPhotoBtn');

    if (animalPhoto) {
        animalPhoto.onchange = event => handleExtraPhotoChange('animal', event);
    }

    if (objectPhoto) {
        objectPhoto.onchange = event => handleExtraPhotoChange('object', event);
    }

    setupExtraPhotoDropZone('animal');
    setupExtraPhotoDropZone('object');

    if (removeAnimalPhotoBtn) {
        removeAnimalPhotoBtn.onclick = () => clearExtraPhoto('animal');
    }

    if (removeObjectPhotoBtn) {
        removeObjectPhotoBtn.onclick = () => clearExtraPhoto('object');
    }

    ['animalDescription', 'objectPhotoDescription', 'objectDescription'].forEach(id => {
        const input = document.getElementById(id);
        if (!input) return;

        input.oninput = function () {
            this.style.borderColor = this.value.trim() ? '#28a745' : '';
        };
    });

    renderStep1ExtraFields();
}

function validateStep1Extras() {
    if (!isExtrasEnabled()) return true;

    const hasExtrasMarkup =
        document.querySelector('input[name="animal_type"]') ||
        document.querySelector('input[name="object_type"]');

    if (!hasExtrasMarkup) return true;

    const animalType = getSelectedExtraType('animal_type');
    const objectType = getSelectedExtraType('object_type');
    const animalPhoto = document.getElementById('animalPhoto');
    const animalDescription = document.getElementById('animalDescription');
    const objectPhoto = document.getElementById('objectPhoto');
    const objectPhotoDescription = document.getElementById('objectPhotoDescription');
    const objectDescription = document.getElementById('objectDescription');
    const animalPhotoZone = document.getElementById('animalPhotoUploadZone');
    const objectPhotoZone = document.getElementById('objectPhotoUploadZone');

    const errors = [];
    let firstInvalidElement = null;

    if (animalType === 'none' && objectType === 'none') {
        errors.push(
            t(
                'errorExtrasEmpty',
                'Add at least one animal or object, or choose No extras.'
            )
        );
        firstInvalidElement = document.getElementById('step1ExtrasPanel');
    }

    if (animalType === 'pet' && !animalPhoto?.files?.[0]) {
        errors.push(
            t('errorAnimalPhotoRequired', 'Please upload a pet photo.')
        );
        animalPhotoZone?.classList.add('invalid');
        if (!firstInvalidElement) firstInvalidElement = animalPhotoZone;
    } else {
        animalPhotoZone?.classList.remove('invalid');
    }

    if (
        animalType === 'favorite_animal' &&
        !animalDescription?.value?.trim()
    ) {
        errors.push(
            t('errorAnimalDescriptionRequired', 'Please describe the animal.')
        );
        if (animalDescription) animalDescription.style.borderColor = '#dc3545';
        if (!firstInvalidElement) firstInvalidElement = animalDescription;
    }

    if (objectType === 'toy' && !objectPhoto?.files?.[0]) {
        errors.push(
            t('errorObjectPhotoRequired', 'Please upload a toy photo.')
        );
        objectPhotoZone?.classList.add('invalid');
        if (!firstInvalidElement) firstInvalidElement = objectPhotoZone;
    } else {
        objectPhotoZone?.classList.remove('invalid');
    }

    if (
        objectType === 'toy' &&
        !objectPhotoDescription?.value?.trim()
    ) {
        errors.push(
            t(
                'errorObjectPhotoDescriptionRequired',
                'Please briefly describe the object in the photo.'
            )
        );
        if (objectPhotoDescription) {
            objectPhotoDescription.style.borderColor = '#dc3545';
        }
        if (!firstInvalidElement) firstInvalidElement = objectPhotoDescription;
    }

    if (
        objectType === 'favorite_object' &&
        !objectDescription?.value?.trim()
    ) {
        errors.push(
            t('errorObjectDescriptionRequired', 'Please describe the object.')
        );
        if (objectDescription) objectDescription.style.borderColor = '#dc3545';
        if (!firstInvalidElement) firstInvalidElement = objectDescription;
    }

    if (errors.length) {
        showError(errors.map(error => `• ${error}`).join('\n'));
        firstInvalidElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
    }

    return true;
}

function getAnimalPersonalizationData() {
    if (!isExtrasEnabled()) return null;

    const type = getSelectedExtraType('animal_type');

    if (type === 'pet') {
        return {
            type,
            name: document.getElementById('animalName')?.value?.trim() || '',
            hasPhoto: true
        };
    }

    if (type === 'favorite_animal') {
        return {
            type,
            description: document.getElementById('animalDescription')?.value?.trim() || ''
        };
    }

    return null;
}

function getObjectPersonalizationData() {
    if (!isExtrasEnabled()) return null;

    const type = getSelectedExtraType('object_type');

    if (type === 'toy') {
        return {
            type,
            hasPhoto: true,
            description: document.getElementById('objectPhotoDescription')?.value?.trim() || ''
        };
    }

    if (type === 'favorite_object') {
        return {
            type,
            description: document.getElementById('objectDescription')?.value?.trim() || ''
        };
    }

    return null;
}

async function nextStepFromStep1() {
    if (DEBUG) console.log('Step 3 → Webhook: book_step1');

    if (!validateBookStep()) {
        // The user is already on Extras. Keep the filled form intact so a
        // temporary variant mismatch cannot trap them on Step 1.
        scrollToPersonalizationTop();
        return false;
    }

    if (!validateStep1()) {
        showStep(2, true);
        return false;
    }

    if (!validateStep1Extras()) return false;

    if (workflowPhase === 'submitting' || setupLocked) return false;
    workflowPhase = 'submitting';

    showStepTransitionLoading(t('loadingSaveBasic', 'Saving basic information...'));

    try {
        const formData = collectStep1Data();

        // ✅ БАГ ФИКС 6: ЖДЕМ RESPONSE и получаем dedication text
        if (DEBUG) console.log('📡 Sending Step 1 data and WAITING for response...');
        const response = await sendToWebhook(formData, 'book_step1');

        if (response?.status === 'contact_support') {
            hideStepTransitionLoading();

            const childName =
                document.getElementById('childName')?.value?.trim() || '';

            showSupportInterventionModal(childName);

            return false;
        }

        if (DEBUG) console.log('✅ Step 1 response received:', response);

        // Сохранить данные
        window.personalizationData = {
            ...window.personalizationData,
            tracking_id: tracking_id,
            childName: document.getElementById('childName').value.trim(),
            gender: document.querySelector('input[name="gender"]:checked').value,
            language: document.getElementById('bookLanguage').value,
            eyeColor: getEyeColorValue(),
            edition: getSelectedEditionValue(),
            extras: getSelectedExtrasValue(),
            selectedVariantId: selectedVariant.id,
            animal: getAnimalPersonalizationData(),
            object: getObjectPersonalizationData()
        //    illustrationStyle: selectedIllustrationStyle
        };

        const responseStartedAt = parseGenerationStartedAt(
            response?.generation_started_at || response?.started_at || response?.created_at
        );
        generationStartedAt = responseStartedAt || Date.now();
        generationDeadlineAt = generationStartedAt + GENERATION_ESTIMATE_MS;
        const configurationLockedAt = Date.now();
        window.personalizationData = {
            ...window.personalizationData,
            generationStartedAt: new Date(generationStartedAt).toISOString(),
            generationStatus: response?.generation_status || response?.status || 'in_process',
            configurationLockedAt: new Date(configurationLockedAt).toISOString()
        };
        setupLocked = true;
        workflowPhase = 'generating';
        lockSetupSteps();
        startPreviewTracking();

        currentStep = 4;
        showStep(currentStep, true);

        // ✅ БАГ ФИКС 6: Извлекаем и заполняем dedication text из webhook response
        let dedicationText = '';

        if (response.dedication) {
            dedicationText = response.dedication;
            if (DEBUG) console.log('📝 Got dedication from response.dedication:', dedicationText);
        } else if (response.dedicationText) {
            dedicationText = response.dedicationText;
            if (DEBUG) console.log('📝 Got dedication from response.dedicationText:', dedicationText);
        } else if (response.message) {
            dedicationText = response.message;
            if (DEBUG) console.log('📝 Got dedication from response.message:', dedicationText);
        } else {
            dedicationText = `Dear ${window.personalizationData.childName}, your amazing adventure begins here! You are special and loved.`;
            if (DEBUG) console.log('📝 Using fallback dedication text');
        }

        // ✅ БАГ ФИКС 6: Заполняем поле dedication полученным текстом
        fillDedicationField(dedicationText);

        // ✅ БАГ ФИКС 1: ТОЛЬКО UI setup, БЕЗ автоматических запросов
        setupStep2Elements();

        hideStepTransitionLoading();

        return true;

    } catch (error) {
        console.error('❌ Step 1 error:', error);
        workflowPhase = 'draft';
        hideStepTransitionLoading();
        showError(t('errorSaveBasic', 'Failed to save basic information'));
        return false;
    }
}

function getProductHandle() {
    return window.personalizationConfig.productHandle;
}

function collectStep1Data() {
    if (DEBUG) console.log('📋 Collecting Step 1 data...');

    const formData = new FormData();
    formData.append('tracking_id', tracking_id);
    formData.append('hbn_token', hbn_token);
    formData.append('product_handle', getProductHandle());
    formData.append('edition', getSelectedEditionValue());
    formData.append('extras_enabled', getSelectedExtrasValue());
    formData.append('selected_variant_id', String(selectedVariant?.id || ''));
    formData.append('selected_variant_price', String(selectedVariant?.price || ''));
    formData.append('child_photo', '');
    formData.append('child_name', document.getElementById('childName').value.trim());
    formData.append('gender', document.querySelector('input[name="gender"]:checked').value);
    formData.append('book_language', document.getElementById('bookLanguage').value);
    formData.append('eye_color', getEyeColorValue());
    //formData.append('illustration_style', selectedIllustrationStyle);


    const photoInput = document.getElementById('childPhoto');
    if (photoInput?.files[0]) {
        formData.set('child_photo', photoInput.files[0]);
    }

    const extrasEnabled = isExtrasEnabled();
    const animalType = extrasEnabled ? getSelectedExtraType('animal_type') : 'none';
    const objectType = extrasEnabled ? getSelectedExtraType('object_type') : 'none';

    formData.append('animal_type', animalType);
    formData.append('object_type', objectType);

    if (animalType === 'pet') {
        const animalPhoto = document.getElementById('animalPhoto');
        const animalName = document.getElementById('animalName');

        if (animalPhoto?.files[0]) {
            formData.append('animal_photo', animalPhoto.files[0]);
        }

        formData.append('animal_name', animalName?.value?.trim() || '');
    } else if (animalType === 'favorite_animal') {
        formData.append(
            'animal_description',
            document.getElementById('animalDescription')?.value?.trim() || ''
        );
    }

    if (objectType === 'toy') {
        const objectPhoto = document.getElementById('objectPhoto');
        const objectPhotoDescription = document.getElementById('objectPhotoDescription');

        if (objectPhoto?.files[0]) {
            formData.append('object_photo', objectPhoto.files[0]);
        }

        formData.append(
            'object_photo_description',
            objectPhotoDescription?.value?.trim() || ''
        );
    } else if (objectType === 'favorite_object') {
        formData.append(
            'object_description',
            document.getElementById('objectDescription')?.value?.trim() || ''
        );
    }

    if (DEBUG) console.log('✅ Step 1 data collected');
    return formData;
}

// ==================== STEP 2: CHARACTER DATA ====================

// ✅ БАГ ФИКС 8: Упрощенная инициализация Step 2 - только текстовые поля
function setupStep2Elements() {
    // ✅ ТОЛЬКО НАСТРОЙКА UI ЭЛЕМЕНТОВ ДЛЯ ТЕКСТОВЫХ ПОЛЕЙ - БЕЗ ЗАПРОСОВ!
    setupCharacterInputs();

    if (DEBUG) console.log('2️⃣ Step 2 elements initialized - simplified UI only, no auto requests');
}

// Убрали функции для эмодзи и выпадающих списков
// setupInterestSelection() - REMOVED
// setupCatchphraseSelection() - REMOVED
// toggleInterest() - REMOVED
// handleCatchphraseSelect() - REMOVED

function setupCharacterInputs() {
    // ✅ БАГ ФИКС 8: Только текстовые поля - traits, superpower, interests, catchphrase
    const inputs = ['traits', 'superpower', 'interests', 'catchphrase'].map(id => document.getElementById(id));

    inputs.forEach(input => {
        if (input) {
            input.addEventListener('input', function() {
                this.style.borderColor = this.value.trim() ? '#28a745' : '#e9ecef';
            });
        }
    });
}

function validateStep2() {
    // Step 2 поля не обязательны
    return true;
}

async function nextStepFromStep2() {
    if (DEBUG) console.log('Step 4 → Step 5: Saving dedication...');

    if (!validateStep2()) return false;

    showStepTransitionLoading(t('loadingSaveCharacter', 'Saving character data...'));

    try {
        const formData = collectAllCharacterData();
        const response = await sendToWebhook(formData, 'book_step2');

        if (DEBUG) console.log('✅ Step 2 response:', response);

        currentStep = 5;
        showStep(currentStep, true);
        initializeStep3();

        hideStepTransitionLoading();
        showSuccess(t('successCharacterSaved', '✅ Character data saved!'));

        return true;

    } catch (error) {
        console.error('❌ Step 2 error:', error);
        hideStepTransitionLoading();
        showError(t('errorSaveCharacter', 'Failed to save character data'));
        return false;
    }
}

function collectAllCharacterData() {
    const formData = new FormData();

    formData.append('tracking_id', tracking_id);
    formData.append('hbn_token', hbn_token);
    formData.append('product_handle', getProductHandle());

    //formData.append('extra_pet', document.getElementById('superpower')?.value.trim() || '');
    //formData.append('extra_human', document.getElementById('catchphrase')?.value.trim() || '');
    //formData.append('hobby', document.getElementById('interests')?.value.trim() || '');
    //formData.append('traits', document.getElementById('traits')?.value.trim() || '');
    formData.append('dedication', document.getElementById('dedication')?.value.trim() || '');

    return formData;
}

// ==================== STEP 3: PREVIEW GENERATION ====================

function initializeStep3() {
  if (DEBUG) console.log('Step 5 initialized');

  const actions = document.getElementById('finalizeActions');
  if (actions) actions.style.display = 'flex';

  hidePreviewError();

  if (previewImages.length) {
    previewExperienceStarted = true;
    hideGenerationProgress();
    showPreviewSlider();
    loadPreviewImages();
  } else {
    // Generation already starts after Step 3. Step 5 immediately connects to
    // the same tracking promise and shows progress without an extra click.
    startStep5PreviewExperience();
  }

  setupPreviewNavigation();

  // ✅ Disable right-click inside the preview slider
  const slider = document.getElementById('previewSliderSection');
  if (slider) {
    slider.addEventListener('contextmenu', e => {
      e.preventDefault();
      return false;
    });
  }
}





async function generatePreview() {
    return startStep5PreviewExperience();
}

function startStep5PreviewExperience() {
    previewExperienceStarted = true;
    hidePreviewError();

    if (previewImages.length) {
        hideGenerationProgress();
        showPreviewSlider();
        loadPreviewImages();
        return Promise.resolve(previewImages);
    }

    hidePreviewSlider();
    showGenerationProgress();
    return startPreviewTracking({ showProgress: true });
}

function parseGenerationStartedAt(value) {
  if (!value) return null;

  if (typeof value === 'number') {
    return value < 1e12 ? value * 1000 : value;
  }

  const numericValue = Number(value);
  if (Number.isFinite(numericValue) && numericValue > 0) {
    return numericValue < 1e12 ? numericValue * 1000 : numericValue;
  }

  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
}

function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, Math.max(0, ms)));
}

function lockSetupSteps() {
  const wrapper = document.getElementById('personalizationFormWrapper');
  if (wrapper) wrapper.dataset.setupLocked = 'true';

  document.querySelectorAll('.step-content[data-step="1"] input, .step-content[data-step="1"] select, .step-content[data-step="1"] button, .step-content[data-step="2"] input, .step-content[data-step="2"] select, .step-content[data-step="2"] button, .step-content[data-step="3"] input, .step-content[data-step="3"] select, .step-content[data-step="3"] button').forEach(element => {
    element.disabled = true;
  });

  updateStepIndicator();
}

function startPreviewTracking(options = {}) {
  const shouldShowProgress = options.showProgress === true;

  if (previewImages.length) return Promise.resolve(previewImages);
  if (previewPollPromise) {
    if (shouldShowProgress) showGenerationProgress();
    return previewPollPromise;
  }

  if (!generationStartedAt) generationStartedAt = Date.now();
  if (!generationDeadlineAt) generationDeadlineAt = generationStartedAt + GENERATION_ESTIMATE_MS;

  previewPollCancelled = false;
  isGeneratingPreview = true;
  resetStep3FinalActionButton();

  if (shouldShowProgress) {
    hidePreviewError();
    hidePreviewSlider();
    showGenerationProgress();
  }

  previewPollPromise = requestPreviewGeneration()
    .then(images => {
      handlePreviewSuccess(images);
      return images;
    })
    .catch(error => {
      handlePreviewError(error);
      return null;
    })
    .finally(() => {
      isGeneratingPreview = false;
      previewPollPromise = null;
    });

  return previewPollPromise;
}

// Timestamp-based 5:30 countdown. It never restarts when the step is reopened.
function hbnShowPreviewCountdown() {
  if (window._hbnPreviewCountdownTimer) {
    clearInterval(window._hbnPreviewCountdownTimer);
    window._hbnPreviewCountdownTimer = null;
  }

  const wrap = document.getElementById('previewCountdownWrap');
  const elTime = document.getElementById('previewCountdown');
  const elSlow = document.getElementById('previewSlowNotice');

  if (!wrap || !elTime) return;

  const render = () => {
    const remaining = Math.max(0, Math.ceil(((generationDeadlineAt || Date.now()) - Date.now()) / 1000));
    const mm = String(Math.floor(remaining / 60)).padStart(2, '0');
    const ss = String(remaining % 60).padStart(2, '0');
    elTime.textContent = `${mm}:${ss}`;
    if (elSlow) elSlow.style.display = remaining === 0 ? 'block' : 'none';
  };

  wrap.style.display = 'block';

  render();

  window._hbnPreviewCountdownTimer = setInterval(render, 1000);
}

function hbnHidePreviewCountdown() {
  if (window._hbnPreviewCountdownTimer) {
    clearInterval(window._hbnPreviewCountdownTimer);
    window._hbnPreviewCountdownTimer = null;
  }
  const wrap = document.getElementById('previewCountdownWrap');
  if (wrap) wrap.style.display = 'none';

  const elSlow = document.getElementById('previewSlowNotice');
  if (elSlow) elSlow.style.display = 'none';
}



// First status check is delayed until three minutes after generation started.
async function requestPreviewGeneration() {
  const startedAt = generationStartedAt || Date.now();
  const firstPollAt = startedAt + FIRST_PREVIEW_POLL_DELAY_MS;
  const stopPollingAt = startedAt + MAX_PREVIEW_WAIT_MS;

  if (Date.now() < firstPollAt) {
    await wait(firstPollAt - Date.now());
  }

  while (!previewPollCancelled && Date.now() < stopPollingAt) {

    // Build request with intention=preview_status
    const formData = new FormData();
    formData.append('tracking_id', tracking_id);
    formData.append('hbn_token', hbn_token);
    formData.append('intention', 'book_preview');

    const { ok, headers, json } = await postWebhookWithHeaders(formData);

    if (!ok) {
      console.warn('Preview status request failed; it will be retried.', json);
      await wait(PREVIEW_POLL_INTERVAL_MS);
      continue;
    }

    const status = (json.status || '').toLowerCase();
    if (DEBUG) console.log(`📡 preview_status:`, status, json);

    if (['done', 'ready', 'completed', 'success'].includes(status)) {
      // normalize image array from various field names
      const urls =
        json.preview_urls ||
        json.image_urls ||
        json.images ||
        json.previews ||
        json.urls ||
        json.previewImages ||
        [];
      const normalized = Array.isArray(urls)
        ? urls.filter(u => typeof u === 'string' && u.startsWith('http'))
        : [];

      if (normalized.length === 0 && typeof json.url === 'string') normalized.push(json.url);
      if (normalized.length === 0 && typeof json.preview_url === 'string') normalized.push(json.preview_url);
      if (normalized.length === 0 && typeof json.image_url === 'string') normalized.push(json.image_url);

      if (normalized.length === 0) throw new Error(t('errorPreviewNoUrls', 'Preview ready but no URLs returned'));
      return normalized;
    }

    if (status === 'error') {
        const msg = t(
            'previewErrorMessage',
            'We’ve been notified and are already checking it. Please keep this page open and try again in a moment.'
    );

    throw new Error(msg);
    }

    let waitMs = Date.now() >= generationDeadlineAt
      ? LATE_PREVIEW_POLL_INTERVAL_MS
      : PREVIEW_POLL_INTERVAL_MS;

    // Allow n8n to override with Retry-After header
    const retryAfterHeader = parseInt(headers.get('Retry-After') || '0', 10);
    if (retryAfterHeader > 0) waitMs = retryAfterHeader * 1000;

    if (DEBUG) console.log(`⏳ Waiting ${Math.round(waitMs / 1000)}s before next poll (status=${status})…`);
    await wait(waitMs);
  }

  throw new Error(t('errorPreviewTimeout', 'Timed out waiting for preview. Please try again later.'));
}

function handlePreviewSuccess(images) {
  if (DEBUG) console.log('🎉 Preview generation successful!');
  if (DEBUG) console.log('📸 Received images:', images);

  // Validate payload
  if (!Array.isArray(images) || images.length === 0) {
    console.error('❌ No images received from webhook');
    handlePreviewError(
      new Error(t('errorGenerationFixing', 'Generation failed. Our team is already fixing the error. Please try again later 🙏'))
    );
    return;
  }

  // Save images + reset slider index
  previewImages = images;
  currentPreviewIndex = 0;
  workflowPhase = 'ready';

  if (!previewExperienceStarted) {
    hideGenerationProgress();
    hidePreviewSlider();
    return;
  }

  // Show the final celebration line (line5) before switching UI
  if (typeof showDoneLine === 'function') showDoneLine();

  // Keep "Hooray!" visible briefly, then reveal the slider
  setTimeout(() => {
    // Hide the dotLottie + spinner text
    if (typeof hideGenerationProgress === 'function') hideGenerationProgress();

    // Show slider and load images
    if (typeof showPreviewSlider === 'function') showPreviewSlider();
    if (typeof loadPreviewImages === 'function') loadPreviewImages();

    // Toast/success note
    if (typeof showSuccess === 'function') showSuccess(t('successPreviewGenerated', '✅ Preview generated!'));

    // Debug -- exposes URLs
    if (DEBUG) {
        console.log('🖼️ Preview images loaded:');
        images.forEach((url, index) => console.log(`  ${index + 1}: ${url}`));
    }
  }, 2000); // increase if you want the “Hooray!” message to linger longer
}



function handlePreviewError(error) {
    console.error('Preview generation failed:', error);
    workflowPhase = 'preview_error';

    const errorMessage = error?.message || t(
      'previewErrorMessage',
      'Preview generation failed. Please try again later.'
    );

    if (previewExperienceStarted) {
      showPreviewInlineError(errorMessage);
    } else {
      hideGenerationProgress();
      hidePreviewSlider();
    }

    if (DEBUG) {
      console.log('Preview error details:', {
        message: error?.message,
        stack: error?.stack,
        trackingId: tracking_id,
        currentStep: currentStep
      });
    }
}

// ==================== ORDER PLACEMENT ====================

async function addToShopifyCart() {
    if (DEBUG) console.log('🛒 Adding to Shopify cart...');

    try {
        // await sendFinalOrderData(); // don't need it to send by pressing "Add to cart". Works together with `async function sendFinalOrderData()`

        // 1) build the line-item properties (collectCartProperties must return { tracking_id, … })
        const properties = collectCartProperties();

        // 2) assemble your payload
        const variantId = getSelectedVariantId();
        if (!variantId) throw new Error(t('errorVariantUnavailable', 'This combination is currently unavailable.'));

        const cartData = {
            id: variantId,
            quantity: 1,
            properties: properties
        };

        // 3) send it to Shopify
        const shopRoot = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData)
        });

        if (!cartResponse.ok) {
            throw new Error(`Cart error: ${cartResponse.status}`);
        }

        const cartResult = await cartResponse.json();
        if (DEBUG) console.log('✅ Added to cart:', cartResult);

        // 1) Fetch the updated drawer (Dawn uses section_id=cart-drawer)
        const drawerSection = await fetch(`${shopRoot}cart?sections=cart-drawer&update=true`, {
          credentials: 'same-origin'
        }).then(r => r.text());

        // 2) Replace the drawer’s HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(drawerSection, 'text/html');
        const newDrawer = doc.querySelector('[data-cart-drawer]');
        const oldDrawer = document.querySelector('[data-cart-drawer]');
        if (newDrawer && oldDrawer) {
          oldDrawer.replaceWith(newDrawer);
        }

        // 3) Open the drawer
        document.querySelector('body').classList.add('cart-drawer--open');

        // ✅ БАГ ФИКС 10: Переходим на Step 4 вместо popup
        currentStep = 5;
        showStep(currentStep);
        workflowPhase = 'added_to_cart';

        const previewState = document.getElementById('step5PreviewState');
        const successState = document.getElementById('step5SuccessState');
        if (previewState) previewState.hidden = true;
        if (successState) successState.hidden = false;
        updateCartUI();

    } catch (error) {
        console.error('❌ Cart error:', error);
        showError(t('errorAddToCart', 'Error adding to cart'));
    }
}

/*
async function sendFinalOrderData() {
    const formData = new FormData();

    formData.append('tracking_id', tracking_id);
    formData.append('hbn_token', generateHbnToken());
    formData.append('order_id', 'shopify_' + Date.now());
    formData.append('timestamp', new Date().toISOString());
    formData.append('client_email', '');
    formData.append('client_fullname', '');
    formData.append('client_phonenumber', '');
    formData.append('client_address', '');

    const response = await sendToWebhook(formData, 'order_paid');
    return response;
}
*/

function collectCartProperties() {
    const data = window.personalizationData || {};

    // ✅ ТОЛЬКО ИМЯ И ЯЗЫК в корзине для простоты
    return {
        '_hbn_token': hbn_token,        // всегда должна стоять на этой позиции "0", т.к. н8н ищет переменную по позиции в properties
        '_tracking_id': tracking_id,    // скрытые properties нормально обрабатываются родными webhooks by Shopify, но не видны для Webhooks App. Если не видит эту переменную = не передаёт в н8н и тогда мы не можем связать № заказа с tracking_id

        'Child Name': data.childName || '',
        'Language': data.language || 'en',
        'Edition': data.edition || getSelectedEditionValue(),
        'Extras': data.extras || getSelectedExtrasValue(),
        'Other fields': data.extras === 'Yes' ? 'Yes' : 'No',
        'Gender': data.gender === 'girl' ? 'Girl' : 'Boy',
        'Eye color': data.eyeColor || '',
        '_selected_variant_id': String(data.selectedVariantId || getSelectedVariantId() || ''),
        '_generation_started_at': data.generationStartedAt || '',
        '_configuration_locked_at': data.configurationLockedAt || '',



        // ✅ СКРЫТЫЕ параметры для внутреннего использования (не отображаются в корзине) Скрытые параметры не передаются по Shopify Webhooks
        /*

        '_illustration_style': selectedIllustrationStyle,
        '_traits': document.getElementById('traits')?.value.trim() || '',
        '_interests': document.getElementById('interests')?.value.trim() || '',
        '_superpower': document.getElementById('superpower')?.value.trim() || '',
        '_catchphrase': document.getElementById('catchphrase')?.value.trim() || '',
        '_dedication': document.getElementById('dedication')?.value.trim() || '',
        '_selected_preview': currentPreviewIndex + 1,
        */
        '_creation_date': new Date().toLocaleDateString('en-US')
    };
}

function getSelectedVariantId() {
  if (selectedVariant?.id) return Number(selectedVariant.id);

  const resolved = resolveVariant();
  return resolved?.available ? Number(resolved.id) : null;
}

// ==================== PREVIEW SLIDER FUNCTIONS ====================

function showPreviewSlider() {
  const sliderSection = document.getElementById('previewSliderSection');
  if (sliderSection) sliderSection.style.display = 'block';

  const actions = document.getElementById('finalizeActions');
  if (actions) actions.style.display = 'flex';

  // ✅ чтобы сразу правильно подсветилось
  updatePreviewNavigation();
}


function hidePreviewSlider() {
  const sliderSection = document.getElementById('previewSliderSection');
  if (sliderSection) sliderSection.style.display = 'none';

  const actions = document.getElementById('finalizeActions');
  if (actions) actions.style.display = 'flex';

}





function loadPreviewImages() {
    if (!previewImages || previewImages.length === 0) {
        console.error('❌ No preview images to load');
        return;
    }

    if (DEBUG) console.log(`🖼️ Loading ${previewImages.length} preview images...`);

    updateMainPreviewImage();
    updatePreviewThumbnails();
    updatePreviewNavigation();

    // Предзагружаем изображения для лучшей производительности
    previewImages.forEach((imageUrl, index) => {
        const img = new Image();
        img.onload = () => {
            if (DEBUG) console.log(`✅ Image ${index + 1} preloaded successfully`);
        };
        img.onerror = () => {
            console.error(`❌ Failed to load image ${index + 1}:`, imageUrl);
        };
        img.src = imageUrl;
    });
}

function updateMainPreviewImage() {
    const mainImg = document.getElementById('mainPreviewImage');
    const currentPage = document.getElementById('currentPreviewPage');
    const totalPages = document.getElementById('totalPreviewPages');

    if (mainImg && previewImages[currentPreviewIndex]) {
        const imageUrl = previewImages[currentPreviewIndex];
        if (DEBUG) console.log(`🖼️ Displaying image ${currentPreviewIndex + 1}:`, imageUrl);

        mainImg.src = imageUrl;

        // inside updateMainPreviewImage(), after mainImg.src = imageUrl;

mainImg.style.cursor = 'zoom-in';

mainImg.onclick = (e) => {
  // только ЛКМ
  if (e.button !== 0) return;
  openPreviewLightbox(imageUrl);
};

        // Добавляем обработчики загрузки для отладки
        if (DEBUG) {
            mainImg.onload = () => {
            console.log(`✅ Main image ${currentPreviewIndex + 1} loaded successfully`);
            }
        };

        mainImg.onerror = () => {
            console.error(`❌ Failed to load main image ${currentPreviewIndex + 1}:`, imageUrl);
            // Можно добавить fallback изображение
            mainImg.src = 'https://via.placeholder.com/400x500/cccccc/666666?text=Image+Not+Found';
        };
    }

    if (currentPage) currentPage.textContent = currentPreviewIndex + 1;
    if (totalPages) totalPages.textContent = previewImages.length;
}

function updatePreviewThumbnails() {
    const thumbnailsContainer = document.querySelector('.preview-thumbnails');
    if (!thumbnailsContainer) return;

    thumbnailsContainer.innerHTML = '';

    previewImages.forEach((imageUrl, index) => {
        const thumbnail = document.createElement('div');
        thumbnail.className = `thumbnail-item ${index === currentPreviewIndex ? 'active' : ''}`;
        thumbnail.onclick = () => selectPreview(index);

        thumbnail.innerHTML = `
            <img src="${imageUrl}" alt="">
            <div class="thumbnail-number">${index + 1}</div>
        `;

        thumbnailsContainer.appendChild(thumbnail);
    });
}

function selectPreview(index) {
    if (index < 0 || index >= previewImages.length) return;

    currentPreviewIndex = index;
    updateMainPreviewImage();

    document.querySelectorAll('.thumbnail-item').forEach((thumb, i) => {
        thumb.classList.toggle('active', i === index);
    });

    // ✅ важно
    updatePreviewNavigation();
}

function previousPreview() {
    if (currentPreviewIndex > 0) {
        selectPreview(currentPreviewIndex - 1);
    }
}

function nextPreview() {
    if (currentPreviewIndex < previewImages.length - 1) {
        selectPreview(currentPreviewIndex + 1);
    }
}

function setArrowState(btn, enabled) {
  if (!btn) return;

  btn.classList.toggle('is-disabled', !enabled);
  btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  btn.tabIndex = enabled ? 0 : -1;

  // На всякий случай: если тема/стили где-то жёстко переопределяют opacity
  btn.style.opacity = enabled ? '1' : '.22';
  btn.style.pointerEvents = enabled ? 'auto' : 'none';
}

function updatePreviewNavigation() {
  const prevBtn = document.getElementById('prevPreviewBtn');
  const nextBtn = document.getElementById('nextPreviewBtn');

  const total = Array.isArray(previewImages) ? previewImages.length : 0;

  // если данных ещё нет — обе “выкл”
  if (total <= 1) {
    setArrowState(prevBtn, false);
    setArrowState(nextBtn, false);
    return;
  }

  const canGoPrev = currentPreviewIndex > 0;
  const canGoNext = currentPreviewIndex < total - 1;

  setArrowState(prevBtn, canGoPrev);
  setArrowState(nextBtn, canGoNext);
}


function setupPreviewNavigation() {
    const prevBtn = document.getElementById('prevPreviewBtn');
    const nextBtn = document.getElementById('nextPreviewBtn');

    if (prevBtn) prevBtn.onclick = previousPreview;
    if (nextBtn) nextBtn.onclick = nextPreview;
}

function generateNewPreviews() {
    generatePreview();
}

/*
// ==================== ILLUSTRATION STYLE FUNCTIONS ====================

function selectIllustrationStyle(element) {
    if (!element?.dataset?.style) return;

    const style = element.dataset.style;

    document.querySelectorAll('.style-btn').forEach(btn => {
        btn.classList.remove('selected');
    });

    element.classList.add('selected');
    selectedIllustrationStyle = style;

    updateIllustrationStyleDisplay(style);

    if (DEBUG) console.log('✅ Illustration style selected:', selectedIllustrationStyle);
}

function updateIllustrationStyleDisplay(style) {
    const styleLabel = document.getElementById('illustrationStyleLabel');
    if (styleLabel) {
        const styleNames = {
            '3d': '3D Style',
            'anime': 'Anime Style',
            'classic': 'Classic Style',
            'comic': 'Comic Style',
            'kawaii': 'Kawaii Style',
            'pixel-block': 'Pixel Block Style'
        };

        const displayName = styleNames[style] || style.toUpperCase();
        styleLabel.textContent = displayName;
        styleLabel.style.color = '#667eea';
        styleLabel.style.fontWeight = 'bold';
    }
}

function initializeDefaultStyle() {
    const defaultStyleBtn = document.querySelector('.style-btn[data-style="3d"]');
    if (defaultStyleBtn) {
        selectIllustrationStyle(defaultStyleBtn);
    } else {
        const firstStyleBtn = document.querySelector('.style-btn');
        if (firstStyleBtn) {
            selectIllustrationStyle(firstStyleBtn);
        }
    }
}
*/

// ==================== PHOTO FUNCTIONS (SIMPLE - NO CROP) ====================

function initializePhotoHandlers() {
    const fileInput = document.getElementById('childPhoto');
    if (fileInput) {
        fileInput.onchange = handlePhotoUpload;
    }

    const previewContainer = document.getElementById('mainPreviewContainer');
    if (previewContainer) {
        previewContainer.onclick = function(e) {
            if (getCurrentStep() === 2) {
                e.preventDefault();
                e.stopPropagation();
                triggerFileUpload();
            }
        };
    }
}

function triggerFileUpload() {
    const fileInput = document.getElementById('childPhoto');
    if (fileInput) fileInput.click();
}

function handlePhotoUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    if (DEBUG) console.log('📸 Processing photo upload...');

    // ✅ БАГ ФИКС 4: Убираем блокировку скролла
    document.body.style.overflow = '';

    if (file.size > MAX_IMAGE_FILE_SIZE) {
        showError(t('errorFileTooLarge', 'File too large. Maximum size: 10MB'));
        event.target.value = '';
        return;
    }

    if (!file.type.startsWith('image/')) {
        showError(t('errorUploadImage', 'Please upload an image file'));
        event.target.value = '';
        return;
    }

    const reader = new FileReader();
    reader.onload = function(e) {
        const imageSrc = e.target.result;
        if (DEBUG) console.log('📸 Image loaded, showing photo preview...');
        showPhotoPreview(imageSrc);
    };

    reader.readAsDataURL(file);
}

function showPhotoPreview(imageSrc) {
    if (DEBUG) console.log('📸 Showing photo preview...');

    const miniPhotoPreview = document.getElementById('miniPhotoPreview');
    const miniPhotoImg = document.getElementById('miniPhotoImg');

    if (miniPhotoImg && miniPhotoPreview) {
        miniPhotoImg.src = imageSrc;

        if (getCurrentStep() === 2) {
            miniPhotoPreview.style.display = 'block';
            miniPhotoPreview.style.opacity = '1';
            miniPhotoPreview.style.visibility = 'visible';
            miniPhotoPreview.classList.add('visible');
        }

        const previewContainer = document.getElementById('mainPreviewContainer');
        if (previewContainer) {
            previewContainer.style.backgroundImage = `url(${imageSrc})`;
            previewContainer.style.backgroundSize = 'cover';
            previewContainer.style.backgroundPosition = 'center';

            const coverText = previewContainer.querySelector('.cover-text');
            if (coverText) {
                coverText.style.opacity = '0.7';
                coverText.style.backgroundColor = 'rgba(255,255,255,0.8)';
                coverText.style.borderRadius = '10px';
                coverText.style.padding = '10px';
            }
        }

        window.photoUploaded = true;
        if (DEBUG) console.log('✅ Photo preview shown successfully!');
    }
}

// ==================== NAVIGATION FUNCTIONS ====================

function nextStep() {
    switch(currentStep) {
        case 1:
            if (!validateBookStep()) return false;
            showStep(2, true);
            return true;
        case 2:
            if (!validateStep1()) return false;
            showStep(3, true);
            return true;
        case 3: return nextStepFromStep1();
        case 4: return nextStepFromStep2();
        default: console.log('No next step available');
    }
}

function previousStep() {
    if (setupLocked) {
        if (currentStep === 5) showStep(4, true);
        return;
    }

    if (currentStep === 2 || currentStep === 3) {
        showStep(currentStep - 1, true);
    }
}

function getPersonalizationHeaderOffset() {
    const candidates = document.querySelectorAll(
        'header-component, .shopify-section-group-header-group, .header-section, .shopify-section--header, #shopify-section-header, header'
    );
    let visibleBottom = 0;

    candidates.forEach(candidate => {
        const rect = candidate.getBoundingClientRect();

        if (
            rect.height > 0 &&
            rect.height < 220 &&
            rect.top <= 8 &&
            rect.bottom > 0
        ) {
            visibleBottom = Math.max(visibleBottom, rect.bottom);
        }
    });

    return Math.max(0, visibleBottom);
}

function scrollToPersonalizationTop() {
    const personalizationSection = document.getElementById('hbn-personalization');
    if (!personalizationSection) return;

    // Wait until the newly selected step has changed the section height.
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const headerOffset = getPersonalizationHeaderOffset();
            const sectionTop = window.scrollY + personalizationSection.getBoundingClientRect().top;
            const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({
                top: Math.max(0, sectionTop - headerOffset - 16),
                behavior: prefersReducedMotion ? 'auto' : 'smooth'
            });
        });
    });
}

function showStep(step, shouldScrollToForm = false) {
    if (DEBUG) console.log(`👁️ Showing step ${step}`);

    if (setupLocked && step <= 3) return false;

    // ✅ БАГ ФИКС 1: Скрываем все step content БЕЗ запросов
    document.querySelectorAll('.step-content').forEach(content => {
        content.style.display = 'none';
        content.classList.remove('active');
    });

    const stepContent = document.querySelector(`.step-content[data-step="${step}"]`);
    if (stepContent) {
        stepContent.style.display = 'block';
        stepContent.classList.add('active');
        if (DEBUG) console.log(`✅ Step ${step} content activated`);
    }

    currentStep = step;
    updateStepIndicator();

    // ✅ БАГ ФИКС 2: Обновляем видимость фото с задержкой
    setTimeout(() => {
        updatePhotoButtonsVisibility();
    }, 50);

    if (shouldScrollToForm) {
        scrollToPersonalizationTop();
    }

    // ✅ БАГ ФИКС 1: НЕ ОТПРАВЛЯЕМ НИКАКИХ ЗАПРОСОВ при смене step
    if (DEBUG) console.log(`🚫 No automatic requests sent for step ${step}`);
    return true;
}

function updateStepIndicator() {
    document.querySelectorAll('.step').forEach((step, index) => {
        const stepNumber = index + 1;

        step.classList.remove('active', 'completed', 'locked');

        if (stepNumber < currentStep) {
            step.classList.add('completed');
        } else if (stepNumber === currentStep) {
            step.classList.add('active');
        }

        if (setupLocked && stepNumber <= 3) step.classList.add('locked', 'completed');
        step.style.display = 'flex';
    });

    const mobileCurrent = document.getElementById('hbnMobileStepCurrent');
    const mobileLabel = document.getElementById('hbnMobileStepLabel');
    const labels = [
        t('stepBook', 'Book'),
        t('stepChild', 'Child'),
        t('stepExtras', 'Extras'),
        t('stepDedication', 'Dedication'),
        t('stepPreview', 'Preview')
    ];

    if (mobileCurrent) mobileCurrent.textContent = String(currentStep);
    if (mobileLabel) mobileLabel.textContent = labels[currentStep - 1] || '';
}

function initializeGlobalNavigation() {
    const navButtons = document.querySelectorAll('.navigation-buttons-step');
    navButtons.forEach(nav => {
        nav.style.display = 'flex';
    });
}

// ==================== UTILITY FUNCTIONS ====================

function getCurrentStep() {
    const activeStep = document.querySelector('.step-content.active');
    return activeStep ? parseInt(activeStep.dataset.step) : 1;
}

function updatePhotoButtonsVisibility() {
    const currentStepNum = getCurrentStep();
    const previewContainer = document.getElementById('mainPreviewContainer');
    const miniPhotoPreview = document.getElementById('miniPhotoPreview');
    const mainPreviewArea = document.getElementById('mainPreviewArea');

    if (DEBUG) console.log(`🔄 Updating photo visibility for step ${currentStepNum}`);

    if (currentStepNum === 2) {
        if (mainPreviewArea) {
            mainPreviewArea.style.display = 'block';
        }

        if (previewContainer) {
            previewContainer.classList.add('clickable');
            previewContainer.style.display = 'flex';
            if (DEBUG) console.log('📸 Preview container made clickable and visible');
        }

        // Показываем мини превью если фото было загружено
        if (window.photoUploaded && miniPhotoPreview) {
            miniPhotoPreview.style.display = 'block';
            miniPhotoPreview.classList.add('visible');
            if (DEBUG) console.log('📸 Mini photo preview shown (photo was uploaded)');
        }
    } else {
        // Step 3+ и Step 4: скрываем все фото элементы
        if (mainPreviewArea) {
            mainPreviewArea.style.display = 'none';
        }

        if (previewContainer) {
            previewContainer.style.display = 'none';
            previewContainer.classList.remove('clickable');
            previewContainer.style.backgroundImage = '';
        }

        if (miniPhotoPreview) {
            miniPhotoPreview.style.display = 'none';
            miniPhotoPreview.classList.remove('visible');
        }
    }
}

function setupDragAndDrop() {
    const previewContainer = document.getElementById('mainPreviewContainer');

    if (previewContainer) {
        previewContainer.addEventListener('dragover', function(e) {
            e.preventDefault();
            previewContainer.style.borderColor = '#667eea';
        });

        previewContainer.addEventListener('dragleave', function(e) {
            e.preventDefault();
            previewContainer.style.borderColor = '';
        });

        previewContainer.addEventListener('drop', function(e) {
            e.preventDefault();
            previewContainer.style.borderColor = '';

            const files = e.dataTransfer.files;
            if (files.length > 0) {
                const file = files[0];
                if (file.type.startsWith('image/')) {
                    const fileInput = document.getElementById('childPhoto');
                    if (fileInput) {
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(file);
                        fileInput.files = dataTransfer.files;

                        handlePhotoUpload({ target: { files: [file] } });
                    }
                } else {
                    showError(t('errorDragImage', 'Please drag an image file'));
                }
            }
        });
    }
}

//Dedication limit
function updateDedicationCharacterCount() {
    const textarea = document.getElementById('dedication');
    const charCount = document.getElementById('charCountDedication');

    if (textarea && charCount) {
        const count = textarea.value.length;
        charCount.textContent = count;

        if (count > 349) {
            charCount.style.color = '#dc3545';
            textarea.value = textarea.value.substring(0, 350);
            charCount.textContent = '350';
        } else if (count > 330) {
            charCount.style.color = '#fd7e14';
        } else {
            charCount.style.color = '#6c757d';
        }
    }
}

function fillDedicationField(dedicationText) {
    if (DEBUG) console.log('📝 Filling dedication field with:', dedicationText);

    const dedicationTextarea = document.getElementById('dedication');

    if (dedicationTextarea) {
        // ✅ БАГ ФИКС 6: Заполняем поле текстом из webhook response
        dedicationTextarea.value = dedicationText || '';
        updateDedicationCharacterCount();

        // ✅ БАГ ФИКС 6: Показываем пользователю что текст загружен
        if (DEBUG) {
            if (dedicationText && dedicationText.length > 10) {
                showSuccess(t('successDedicationLoaded', '📝 Dedication text loaded automatically!'));
            }
        }
    } else {
        console.error('❌ Dedication textarea not found!');
    }
}

// ==================== UI HELPER FUNCTIONS ====================

// переключение кнопки Step 3
function resetStep3FinalActionButton() {
  const btn = document.getElementById('step3FinalActionBtn');
  if (!btn) return;

  btn.textContent = t('addToCart', 'Add to cart');
  btn.className = 'nav-step-btn nav-next add-to-cart-btn';
  btn.onclick = addToShopifyCart;
}

function setStep3FinalActionToRestart() {
  const actions = document.getElementById('finalizeActions');
  const btn = document.getElementById('step3FinalActionBtn');

  if (actions) actions.style.display = 'flex';
  if (!btn) return;

  btn.textContent = t('startOver', 'Start over');
  btn.className = 'finalize-btn hbn-step4-btn hbn-step4-btn-secondary';
  btn.onclick = function () {
    window.location.reload();
  };
}

// Controls visibility of the "What happens next" button via a .show class
function setWhatNextVisible(isVisible) {
  const btn = document.getElementById('whatNextBtn');
  if (!btn) return;
  btn.classList.toggle('show', !!isVisible);
}

// Sync button with current slider visibility (useful on step re-entry)
function syncWhatNextToSlider() {
  const slider = document.getElementById('previewSliderSection');
  const visible = !!(slider && getComputedStyle(slider).display !== 'none');
  setWhatNextVisible(visible);
}


function showGenerationProgress() {
  setWhatNextVisible(false);

  const lottieWrap = document.getElementById('previewLottieSection');
  if (lottieWrap) lottieWrap.style.display = 'block';

  hbnShowPreviewCountdown();

  startLottieTextSpinner();
}


// Show preview error message
function setPreviewErrorVisible(isVisible, message = '') {
  const wrap = document.getElementById('previewErrorSection');
  const text = document.getElementById('previewErrorMessage');

  if (!wrap) return;

  if (text && message) {
    text.textContent = decodeHtmlEntities(message);
  }

  wrap.style.display = isVisible ? 'block' : 'none';
}

function hidePreviewError() {
  setPreviewErrorVisible(false);
}

function showPreviewInlineError(message) {
  hideGenerationProgress();
  hidePreviewSlider();
  setWhatNextVisible(false);

  const fallbackMessage = t(
    'previewErrorMessage',
    'We’ve been notified and are already checking it. Please keep this page open and try again in a moment.'
  );

  setPreviewErrorVisible(true, message || fallbackMessage);
}

function retryPreviewAfterError() {
  hidePreviewError();
  previewExperienceStarted = true;
  showGenerationProgress();
  startPreviewTracking({ showProgress: true });
}





function hideGenerationProgress() {
  // Hide dotLottie + stop spinner
  stopLottieTextSpinner();

  // ✅ СКРЫВАЕМ ТАЙМЕР
  hbnHidePreviewCountdown();

  const lottieWrap = document.getElementById('previewLottieSection');
  if (lottieWrap) lottieWrap.style.display = 'none';

  if (window.currentProgressInterval) {
    clearInterval(window.currentProgressInterval);
    window.currentProgressInterval = null;
  }
}



// ==================== NOTIFICATION FUNCTIONS ====================

function showError(message) {
    console.error('❌ Error:', message);
    showNotification(message, 'error');
}

function showSuccess(message) {
    if (DEBUG) console.log('✅ Success:', message);
    showNotification(message, 'success');
}

function showNotification(message, type = 'info') {
    const existing = document.getElementById('notification');
    if (existing) existing.remove();

    const colors = {
        error: '#dc3545',
        success: '#28a745',
        info: '#17a2b8'
    };

    const notification = document.createElement('div');
    notification.id = 'notification';
    notification.style.cssText = `
        position: fixed; top: 20px; right: 20px; background: ${colors[type]};
        color: white; padding: 15px 20px; border-radius: 8px; z-index: 9999;
        font-family: 'Sour Gummy'; font-size: 0.9rem;
        box-shadow: 0 4px 12px rgba(0,0,0,0.3); max-width: 300px;
        opacity: 0; transform: translateX(100%); transition: all 0.3s ease;
        white-space: pre-line; line-height: 1.5;
    `;

    notification.textContent = decodeHtmlEntities(message);
    document.body.appendChild(notification);

    requestAnimationFrame(() => {
        notification.style.opacity = '1';
        notification.style.transform = 'translateX(0)';
    });

    setTimeout(() => {
        if (document.body.contains(notification)) {
            notification.style.opacity = '0';
            notification.style.transform = 'translateX(100%)';
            setTimeout(() => notification.remove(), 300);
        }
    }, type === 'error' ? 5000 : 3000);
}

function showStepTransitionLoading(message) {
    const loadingDiv = document.createElement('div');
    loadingDiv.id = 'stepTransitionLoading';
    loadingDiv.style.cssText = `
        position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.8); color: white; padding: 20px 30px;
        border-radius: 10px; z-index: 9999; font-family: 'Sour Gummy';
        text-align: center; display: flex; align-items: center; gap: 15px;
    `;

    loadingDiv.innerHTML = `
        <div style="width: 20px; height: 20px; border: 2px solid #f3f3f3;
            border-top: 2px solid #667eea; border-radius: 50%;
            animation: spin 1s linear infinite;"></div>
        <span>${message}</span>
    `;

    document.body.appendChild(loadingDiv);
}

function hideStepTransitionLoading() {
    const loadingDiv = document.getElementById('stepTransitionLoading');
    if (loadingDiv) loadingDiv.remove();
}

function updateCartUI() {
    const shopRoot = window.Shopify?.routes?.root || '/';
    fetch(`${shopRoot}cart.js`)
        .then(response => response.json())
        .then(cart => {
            const generic = document.querySelector('.cart-count, [data-cart-count]');
            if (generic) generic.textContent = cart.item_count;

            // Horizon-specific header badge:
            const horizonBadge = document.querySelector('.header-minicart__count-num');
            if (horizonBadge) {
              horizonBadge.textContent = cart.item_count;
              // hide it when it's zero, if you like
              horizonBadge.parentElement.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
            }
        })
        .catch(error => console.log('Cart UI update failed:', error));
}

function openHbnModal(modal, focusTarget) {
  if (!modal) return;
  modal.style.display = 'flex';
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => focusTarget?.focus());
}

function closeHbnModal(modal) {
  if (!modal) return;
  modal.style.display = 'none';
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// photo guidelines popup
const photoBtn = document.getElementById('photoReqBtn');
const photoModal = document.getElementById('photoReqModal');
const photoClose = document.getElementById('photoReqClose');

if (photoBtn && photoModal && photoClose) {
  photoBtn.addEventListener('click', () => {
    openHbnModal(
      photoModal,
      photoModal.querySelector('.hbn-tab-btn.active') || photoClose
    );
  });
  photoClose.addEventListener('click', () => {
    closeHbnModal(photoModal);
  });
  // close when clicking outside content
  photoModal.addEventListener('click', e => {
    if (e.target === photoModal) closeHbnModal(photoModal);
  });
};

// Photo Guidelines modal tabs
function initPhotoModalTabs() {
  const modal = document.getElementById('photoReqModal');
  if (!modal) return;

  const tabButtons = modal.querySelectorAll('.hbn-tab-btn[data-tab]');
  const panels = modal.querySelectorAll('.hbn-tab-panel');

  function activateTab(tabId) {
    // buttons
    tabButtons.forEach(btn => {
      const isActive = btn.dataset.tab === tabId;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    // panels
    panels.forEach(p => {
      p.classList.toggle('active', p.id === tabId);
    });
  }

  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => activateTab(btn.dataset.tab));
  });

  // When modal opens, always start from tab 1
  const photoBtn = document.getElementById('photoReqBtn');
  if (photoBtn) {
    photoBtn.addEventListener('click', () => activateTab('photoTab1'));
  }
}

initPhotoModalTabs();


document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;

  if (photoModal?.style.display === 'flex') {
    closeHbnModal(photoModal);
  }
});

// ==================== PREVIEW LIGHTBOX (square + nav) ====================

let _hbnLightboxIndex = 0;

function _hbnSetArrowState(btn, enabled) {
  if (!btn) return;
  btn.classList.toggle('is-disabled', !enabled);
  btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  btn.tabIndex = enabled ? 0 : -1;
}

function _hbnRenderLightbox() {
  const img = document.getElementById('previewLightboxImg');
  const indicator = document.getElementById('previewLightboxIndicator');
  const prevBtn = document.getElementById('previewLightboxPrev');
  const nextBtn = document.getElementById('previewLightboxNext');

  const total = Array.isArray(previewImages) ? previewImages.length : 0;
  if (!img || total === 0) return;

  const url = previewImages[_hbnLightboxIndex];
  img.src = url;

  if (indicator) indicator.textContent = `${_hbnLightboxIndex + 1} / ${total}`;

  _hbnSetArrowState(prevBtn, _hbnLightboxIndex > 0);
  _hbnSetArrowState(nextBtn, _hbnLightboxIndex < total - 1);
}

function openPreviewLightbox(indexOrUrl) {
  const modal = document.getElementById('previewLightbox');
  const img = document.getElementById('previewLightboxImg');
  const square = document.getElementById('previewLightboxSquare');
  if (!modal || !img || !square) return;

  // определить индекс
  if (typeof indexOrUrl === 'number') {
    _hbnLightboxIndex = Math.max(0, Math.min(indexOrUrl, (previewImages?.length || 1) - 1));
  } else if (typeof indexOrUrl === 'string') {
    const i = Array.isArray(previewImages) ? previewImages.indexOf(indexOrUrl) : -1;
    _hbnLightboxIndex = i >= 0 ? i : currentPreviewIndex || 0;
  } else {
    _hbnLightboxIndex = currentPreviewIndex || 0;
  }

  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  // блок ПКМ и drag
  modal.addEventListener('contextmenu', e => e.preventDefault(), { passive: false });
  img.addEventListener('contextmenu', e => e.preventDefault(), { passive: false });
  img.addEventListener('dragstart', e => e.preventDefault());

  _hbnRenderLightbox();
}

function closePreviewLightbox() {
  const modal = document.getElementById('previewLightbox');
  const img = document.getElementById('previewLightboxImg');
  if (!modal || !img) return;

  modal.style.display = 'none';
  img.src = '';
  document.body.style.overflow = '';
}

function lightboxPrev() {
  if (_hbnLightboxIndex > 0) {
    _hbnLightboxIndex -= 1;
    _hbnRenderLightbox();
  }
}

function lightboxNext() {
  const total = Array.isArray(previewImages) ? previewImages.length : 0;
  if (_hbnLightboxIndex < total - 1) {
    _hbnLightboxIndex += 1;
    _hbnRenderLightbox();
  }
}

function initPreviewLightbox() {
  const modal = document.getElementById('previewLightbox');
  const closeBtn = document.getElementById('previewLightboxClose');
  const prevBtn = document.getElementById('previewLightboxPrev');
  const nextBtn = document.getElementById('previewLightboxNext');

  if (!modal || !closeBtn || !prevBtn || !nextBtn) return;

  closeBtn.addEventListener('click', closePreviewLightbox);
  prevBtn.addEventListener('click', lightboxPrev);
  nextBtn.addEventListener('click', lightboxNext);

  // клик по оверлею закрывает
  modal.addEventListener('click', e => {
    if (e.target === modal) closePreviewLightbox();
  });

  // ESC + стрелки
  document.addEventListener('keydown', e => {
    if (modal.style.display === 'none') return;

    if (e.key === 'Escape') closePreviewLightbox();
    if (e.key === 'ArrowLeft') lightboxPrev();
    if (e.key === 'ArrowRight') lightboxNext();
  });
}

initPreviewLightbox();


// ==================== GLOBAL FUNCTIONS ====================

// Make functions globally available (Updated for simplified Step 2)
window.nextStep = nextStep;
window.previousStep = previousStep;
// window.selectIllustrationStyle = selectIllustrationStyle;	//for Illustration style
window.updateDedicationCharacterCount = updateDedicationCharacterCount;
window.generatePreview = generatePreview;
window.generateNewPreviews = generateNewPreviews;
window.selectPreview = selectPreview;
window.previousPreview = previousPreview;
window.nextPreview = nextPreview;
window.addToShopifyCart = addToShopifyCart;
window.triggerFileUpload = triggerFileUpload;
window.handlePhotoUpload = handlePhotoUpload;
window.openStep1Extras = openStep1Extras;
window.returnToStep1Child = returnToStep1Child;

// Initialize global personalization data
window.personalizationData = window.personalizationData || {};

// ==================== DEBUG ====================

window.debugPersonalization = function() {
    return {
        tracking_id,
        //selectedIllustrationStyle,
        personalizationData: window.personalizationData,
        currentStep,
        previewImages: previewImages.length,
        hbnToken: hbn_token,
        workflowPhase,
        setupLocked,
        selectedVariant,
        generationStartedAt,
        photoUploaded: window.photoUploaded,
        // Updated for simplified Step 2
        traits: document.getElementById('traits')?.value || '',
        interests: document.getElementById('interests')?.value || '',
        superpower: document.getElementById('superpower')?.value || '',
        catchphrase: document.getElementById('catchphrase')?.value || '',
        dedication: document.getElementById('dedication')?.value || ''
    };
};

// Add CSS for animations
const style = document.createElement('style');
style.textContent = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
document.head.appendChild(style);


function decodeHtmlEntities(str = '') {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
}
